import React, { useEffect, useState, useContext, useRef, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";



import { formatIndianCurrency, convertStrToNumber } from "../../helper/ConvertValue";
import { updateConventionalMode, batchUpdateConventionalMode } from "../../redux/actions/TemplateTabs/actionCM";

import commoncss from "../../myfin_v2/css/common.module.css";
import buttoncss from "../../myfin_v2/css/button.module.css";
import tablecss from "../../myfin_v2/css/table.module.css";
import ReactIcon from "../../myfin_v2/css/table.module.css";
import { ReactComponent as AddIcon } from "../../myfin_v2/assets/icons/addEcl.svg";
import { ReactComponent as BackIcon } from "../../myfin_v2/assets/icons/left_arrow.svg";
import { ReactComponent as EditIcon } from "../../myfin_v2/assets/icons/edit.svg";
import { ReactComponent as DeleteIcon } from "../../myfin_v2/assets/icons/delete_red.svg";
import { ReactComponent as AddElement } from "../../myfin_v2/assets/icons/grayAddIcon.svg";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";
import { ThemeContext } from "../../helper/DarkModeContext";
import { Button } from "../../myfin_v2/elements/Button";
import "./templateTabs.css";
import axios from "axios";
import DeletePopup from "../../myfin_v2/elements/DeletePopup";
import SuccessPopup from "../../myfin_v2/elements/SuccessPopup";
import ErrorPopup from "../../myfin_v2/elements/ErrorPopup";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import sidePanelStyles from "../../myfin_v2/css/cashFlowTable.module.css";
import libcss from "../../myfin_v2/css/library.module.css";
import Dropdown from "../../myfin_v2/elements/Dropdown";
import InputGroup from "../../myfin_v2/elements/InputGroup";
import { ReactComponent as PlusIcon } from "../../myfin_v2/assets/icons/formulaPlus.svg";
import { ReactComponent as AddPlusIcon } from "../../myfin_v2/assets/icons/grayPlus.svg";
import { ReactComponent as MinusIcon } from "../../myfin_v2/assets/icons/MinusIcon.svg";
import { ReactComponent as MultiplyIcon } from "../../myfin_v2/assets/icons/MultiplyIcon.svg";
import { ReactComponent as DivisionIcon } from "../../myfin_v2/assets/icons/DivisionIcon.svg";
import { TbPlus, TbMinus, TbX, TbDivide } from "react-icons/tb";

const OPERATORS = ["＋", "－", "×", "÷"];

const operatorMap = {
  "＋": "positive",
  "－": "negative",
  "×": "multiply",
  "÷": "divide"
};

const reverseOperatorMap = {
  "positive": "＋",
  "negative": "－",
  "multiply": "×",
  "divide": "÷"
};

const OPERATOR_MAP = {
  "＋": "+",
  "－": "-",
  "×": "*",
  "÷": "/",
};

const OperatorIcon = ({ type, size = 18, strokeWidth = 2 }) => {
  switch(type) {
    case "＋":
    case "+": return <TbPlus size={size} strokeWidth={strokeWidth} />;
    case "－":
    case "-": return <TbMinus size={size} strokeWidth={strokeWidth} />;
    case "×":
    case "*": return <TbX size={size} strokeWidth={strokeWidth} />;
    case "÷":
    case "/": return <TbDivide size={size} strokeWidth={strokeWidth} />;
    default: return <TbPlus size={size} strokeWidth={strokeWidth} />;
  }
};

const operatorOptions = [
  { value: "positive", label: "positive", symbol: "+", Icon: PlusIcon },
  { value: "negative", label: "negative", symbol: "-", Icon: MinusIcon },
  { value: "multiply", label: "multiply", symbol: "×", Icon: MultiplyIcon },
  { value: "divide", label: "divide", symbol: "÷", Icon: DivisionIcon },
];

const OperatorBtn = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    if (!open) return;
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [open]);

  return (
    <div ref={ref} style={{ position: "relative", display: "flex", flexDirection: "column", alignItems: "center", flexShrink: 0 }}>
      {open && (
        <div 
          className={sidePanelStyles.operatorPopup} 
          style={{ 
            position: "absolute", 
            bottom: "-70px", 
            left: "50%", 
            transform: "translateX(-50%)", 
            zIndex: 99
          }}
        >
          {OPERATORS.map((op) => (
            <div
              key={op}
              className={`${sidePanelStyles.operatorItem} ${value === op || reverseOperatorMap[value] === op ? sidePanelStyles.activeOperator : ""}`}
              onClick={() => { 
                onChange(operatorMap[op] || "positive"); 
                setOpen(false); 
              }}
            >
              <OperatorIcon type={op} size={18}/>
            </div>
          ))}
        </div>
      )}
      <div
        style={{ display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", width: "32px", height: "32px" }}  
        className={sidePanelStyles.addBtn}
        onClick={() => setOpen((o) => !o)}
        title="Change operator"
      >
        <OperatorIcon type={reverseOperatorMap[value] || value} size={16}  />
      </div>
    </div>
  );
};

const ToggleSwitch = ({ label, checked, onChange }) => {
  return (
    <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", userSelect: "none" }}>
      <div
        onClick={() => onChange && onChange(!checked)}
        style={{
          width: "36px",
          height: "20px",
          borderRadius: "10px",
          backgroundColor: checked ? "#3AB67D" : "#cbd5e1",
          position: "relative",
          transition: "background-color 0.2s ease",
          cursor: "pointer"
        }}
      >
        <div
          style={{
            width: "16px",
            height: "16px",
            borderRadius: "50%",
            backgroundColor: "#ffffff",
            position: "absolute",
            top: "2px",
            left: checked ? "18px" : "2px",
            transition: "left 0.2s ease",
            boxShadow: "0 1px 3px rgba(0,0,0,0.15)"
          }}
        />
      </div>
      <span style={{ fontSize: "14px", color: "#33584E", fontWeight: "500" }}>{label}</span>
    </label>
  );
};

/**
 * GroupingDrilldownTable
 *
 * Props:
 *  - grouping: array (grouping structure)
 *
 * Behavior:
 *  - Accepts drops only on level-3 rows.
 *  - Reads dropped payload (tries application/json, text/plain, then global fallback).
 *  - Extracts cy/py (or currentYear/previousYear variants) and updates the specific level-3 row.
 *  - Persists mapped values and updates the visible grouping optimistically.
 */
const GroupingDrilldownTable = ({
  grouping = [],
  onAfterDrop,
  view: externalView,
  setView: externalSetView,
  setUpdateTabs,
  selectedL1,
  selectedL2,
  setExternalSelection,
  containerRef,
  refreshMappingData,
  category,
  currentYear,
  previousYear,
}) => {
  const conventionModeData = useSelector(
    (state) => state.ConventionModeReducer
  );
  const { checkYearly } = useSelector(
    (state) => state.selectedDragReducer
  );
  const dispatch = useDispatch();

  const { theme } = useContext(ThemeContext);
  // internal editable copy of grouping
  const [data, setData] = useState(grouping || []);

  const [showAddL2Modal, setShowAddL2Modal] = useState(false);
  const [showAddL1Modal, setShowAddL1Modal] = useState(false);
  const [activeL1, setActiveL1] = useState(null);
  const [noteName, setNoteName] = useState("");

  const [showAddL3Modal, setShowAddL3Modal] = useState(false);
  const [activeL2, setActiveL2] = useState(null);
  const [lineItemName, setLineItemName] = useState("");

  const [selectedItem, setSelectedItem] = useState("line item");
  const [itemName, setItemName] = useState("");
  const [lineItemNature, setLineItemNature] = useState("credit");
  const [formulaItems, setFormulaItems] = useState([
    { element: Date.now(), value: "", operator: "positive" },
  ]);
  const [pendingOperator, setPendingOperator] = useState("positive");

  const [isBold, setIsBold] = useState(false);
  const [isTotal, setIsTotal] = useState(false);
  const [isSubtotal, setIsSubtotal] = useState(false);

  // Edit-related state hooks
  const [editingItem, setEditingItem] = useState(null);
  const [editItemName, setEditItemName] = useState("");
  const [editSelectedItem, setEditSelectedItem] = useState("line item");
  const [editLineItemNature, setEditLineItemNature] = useState("credit");
  const [editFormulaItems, setEditFormulaItems] = useState([
    { element: Date.now(), value: "", operator: "positive" },
  ]);
  const [editPendingOperator, setEditPendingOperator] = useState("positive");
  const [editIsBold, setEditIsBold] = useState(false);
  const [editIsTotal, setEditIsTotal] = useState(false);
  const [editIsSubtotal, setEditIsSubtotal] = useState(false);

  // Hover and update state hooks
  const [hoveredL2Id, setHoveredL2Id] = useState(null);
  const [hoveredL1Id, setHoveredL1Id] = useState(null);
  const [hoveredL3Id, setHoveredL3Id] = useState(null);
  const [draggingL2Id, setDraggingL2Id] = useState(null);
  const l2DragScrollRef = useRef(null);
  const [draggingL3Id, setDraggingL3Id] = useState(null);

  // Custom Popup state
  const [successPopupMessage, setSuccessPopupMessage] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [errorData, setErrorData] = useState(null);

  const [deleteConfirmData, setDeleteConfirmData] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [updatedL2, setUpdatedL2] = useState([]);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [highlightedNoteId, setHighlightedNoteId] = useState(null);

  const lastScrollPosRef = useRef(parseInt(sessionStorage.getItem("l3DragScroll") || "0", 10));
  const skipNextScrollEvent = useRef(false);
  const ignoreScrollResetsRef = useRef(false);
  const ignoreScrollTimeoutRef = useRef(null);
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  // Internal view state
  const [internalView, setInternalView] = useState(() => {
    const saved = sessionStorage.getItem("view");
    return saved
      ? JSON.parse(saved)
      : { type: "root", level1: null, level2: null };
  });

  // Variables derived from state/props
  const view = internalView ?? externalView ?? { type: "root", level1: null, level2: null };
  const project_id = localStorage.getItem("project_id");
  const currentCategory = category 
    || activeL1?.category 
    || view?.level1?.category 
    || (data && data.length > 0 && data[0]?.category) 
    || (grouping && grouping.length > 0 && grouping[0]?.category) 
    || "BS";

  const hasDisplayValue = (value) =>
    value !== null && value !== undefined && value !== "";

  const isStandaloneLevel1 = (item) =>
    !Array.isArray(item?.subgroup) || item.subgroup.length === 0;

  const setView = (newView) => {
    setInternalView(newView);
    if (externalSetView) {
      externalSetView(newView);
    }
  };

  const addEditFormulaItem = () => {
    setEditFormulaItems((prev) => [
      ...prev,
      { element: Date.now(), value: "", operator: editPendingOperator },
    ]);
    setEditPendingOperator("positive");
  };

  const updateEditFormulaItem = (index, val) => {
    setEditFormulaItems((prev) => {
      const copy = [...prev];
      copy[index] = { ...copy[index], value: val };
      return copy;
    });
  };

  const updateEditFormulaOperator = (index, val) => {
    setEditFormulaItems((prev) => {
      const copy = [...prev];
      copy[index] = { ...copy[index], operator: val };
      return copy;
    });
  };

  const handleEditTotalToggle = (val) => {
    setEditIsTotal(val);
    if (val) {
      setEditIsBold(true);
      setEditIsSubtotal(false);
    }
  };

  const handleEditSubtotalToggle = (val) => {
    setEditIsSubtotal(val);
    if (val) {
      setEditIsBold(true);
      setEditIsTotal(false);
    }
  };

  const renderFormulaDisplay = (items) => {
    if (!items || items.length === 0) {
      return <span style={{ color: "#B3C0BD" }}>(no formula selected)</span>;
    }
    const pieces = items.map((it) => {
      if (!it || !it.value) return "(?)";
      if (typeof it.value === "string") return it.value;
      if (it.value.label) return it.value.label;
      return it.value.value ?? "(?)";
    });

    return (
      <span style={{ display: "inline-flex", alignItems: "center", flexWrap: "wrap", gap: "2px", verticalAlign: "middle" }}>
        <span>{pieces[0] || ""}</span>
        {items.slice(1).map((item, index) => {
          return (
            <React.Fragment key={index}>
              <span style={{ 
                display: "inline-flex", 
                alignItems: "center", 
                justifyContent: "center",
                margin: "0 4px",
                verticalAlign: "middle"
              }}>
                <span style={{ 
                  color: "#99ABA7", 
                  fontSize: "18px", 
                  fontWeight: "500",
                  lineHeight: "1",
                  userSelect: "none",
                  transform: "translateY(-1.5px)"
                }}>(</span>
                <span style={{ 
                  display: "inline-flex", 
                  alignItems: "center", 
                  justifyContent: "center",
                  color: "#205a46",
                  margin: "0 3px",
                  transform: "translateY(-2px)"
                }}>
                  <OperatorIcon type={reverseOperatorMap[item.operator] || item.operator} size={12} strokeWidth={3.5} />
                </span>
                <span style={{ 
                  color: "#99ABA7", 
                  fontSize: "18px", 
                  fontWeight: "500",
                  lineHeight: "1",
                  userSelect: "none",
                  transform: "translateY(-1.5px)"
                }}>)</span>
              </span>
              <span>{pieces[index + 1]}</span>
            </React.Fragment>
          );
        })}
      </span>
    );
  };

  const editFormulaDisplayString = (() => {
    if (!editFormulaItems || editFormulaItems.length === 0) return "";
    const pieces = editFormulaItems.map((it) => {
      if (!it || !it.value) return "(?)";
      if (typeof it.value === "string") return it.value;
      if (it.value.label) return it.value.label;
      return it.value.value ?? "(?)";
    });
    let display = pieces[0] || "";
    for (let i = 1; i < pieces.length; i++) {
      const op = operatorOptions.find(
        (o) => o.value === editFormulaItems[i].operator
      );
      display += ` (${op?.symbol ?? "+"}) ${pieces[i]}`;
    }
    return display;
  })();

  const getEditingDropdownOptions = () => {
    if (!editingItem) return [];
    const { level, levelOneID, levelTwoID } = editingItem;
    if (level === 1) {
      return (data || [])
        .filter((sub) => sub && sub.name && !sub.isNewRow)
        .map((sub) => ({ label: sub.name, value: sub.name }));
    } else if (level === 2) {
      const l1 = data.find(x => x._id === levelOneID);
      return (l1?.subgroup || [])
        .filter((sub) => sub && sub.name && !sub.isNewRow)
        .map((sub) => ({ label: sub.name, value: sub.name }));
    } else if (level === 3) {
      const l1 = data.find(x => x._id === levelOneID);
      const l2 = l1?.subgroup?.find(x => x._id === levelTwoID);
      return (l2?.subgroup || [])
        .filter((sub) => sub && sub.name && !sub.isNewRow)
        .map((sub) => ({ label: sub.name, value: sub.name }));
    }
    return [];
  };

  const formatHeaderDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;

    const day = String(date.getDate()).padStart(2, '0');
    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  };

  const currentYearLabel = currentYear ? formatHeaderDate(currentYear) : "";
  const previousYearLabel = previousYear ? formatHeaderDate(previousYear) : "";

  // Sync internal data whenever parent pushes updated grouping prop
  useEffect(() => {
    if (grouping && grouping.length > 0) {
      setData(grouping);
    }
  }, [grouping]);

  useEffect(() => {
    if (!editingItem) {
      setEditItemName("");
      setEditSelectedItem("line item");
      setEditLineItemNature("credit");
      setEditIsBold(false);
      setEditIsTotal(false);
      setEditIsSubtotal(false);
      setEditFormulaItems([{ element: Date.now(), value: "", operator: "positive" }]);
      setEditPendingOperator("positive");
      return;
    }

    const { level, levelOneID, levelTwoID, levelThreeID } = editingItem;
    let foundItem = null;
    if (level === 1) {
      foundItem = data.find(x => x._id === levelOneID);
    } else if (level === 2) {
      const l1 = data.find(x => x._id === levelOneID);
      foundItem = l1?.subgroup?.find(x => x._id === levelTwoID);
    } else if (level === 3) {
      const l1 = data.find(x => x._id === levelOneID);
      const l2 = l1?.subgroup?.find(x => x._id === levelTwoID);
      foundItem = l2?.subgroup?.find(x => x._id === levelThreeID);
    }

    if (foundItem) {
      setEditItemName(foundItem.name || "");
      setEditSelectedItem(foundItem.lineType || "line item");
      setEditLineItemNature(foundItem.nature || "credit");
      setEditIsBold(foundItem.isBold || false);
      setEditIsTotal(foundItem.formulaType === "total");
      setEditIsSubtotal(foundItem.formulaType === "subtotal");
      
      const dbFormula = foundItem.formula || [];
      if (dbFormula.length > 0) {
        setEditFormulaItems(dbFormula.map((term, index) => ({
          element: Date.now() + index,
          value: term.name || "",
          operator: term.sign || "positive"
        })));
      } else {
        setEditFormulaItems([{ element: Date.now(), value: "", operator: "positive" }]);
      }
      setEditPendingOperator("positive");
    }
  }, [editingItem, data]);

  useEffect(() => {
    setIsBold(false);
    setIsTotal(false);
    setIsSubtotal(false);
  }, [showAddL2Modal, showAddL3Modal, showAddL1Modal]);

  const handleTotalToggle = (val) => {
    setIsTotal(val);
    if (val) {
      setIsBold(true);
      setIsSubtotal(false);
    }
  };

  const handleSubtotalToggle = (val) => {
    setIsSubtotal(val);
    if (val) {
      setIsBold(true);
      setIsTotal(false);
    }
  };

  // State hooks moved to top
  const auth = localStorage.getItem("auth_token");
  const headers = {
    "x-auth-token": auth,
    "Content-Type": "application/json",
  };


  const handleCreateL1 = async () => {
    const finalName = itemName.trim();
    if (!finalName) {
      setErrorData({ title: "Warning", message: "Please enter Category Name" });
      return;
    }
    
    setIsUpdating(true);
    try {
      const returnFormulaItems = selectedItem === "formula"
        ? formulaItems.filter(x => x.value).map(x => ({
            name: typeof x.value === "string" ? x.value : x.value.value ?? x.value.label ?? "",
            sign: x.operator ?? "positive"
          }))
        : [];

      const payload = {
        level: 1,
        item: {
          category: currentCategory,
          lineType: selectedItem,
          name: finalName,
          nature: selectedItem === "line item" ? lineItemNature : undefined,
          formula: selectedItem === "formula" ? returnFormulaItems : undefined,
          formulaType: isTotal ? "total" : isSubtotal ? "subtotal" : undefined,
          isBold: isBold || isTotal || isSubtotal,
        }
      };
      
      await axios.post(`/api/v1/populateFS/addGroupingItem?projectID=${project_id}`, payload, { headers });
      if (!isMounted.current) return;
      setSuccessPopupMessage("Category created successfully");
      setShowSuccessPopup(true);
      setShowAddL1Modal(false);

      if (refreshMappingData) {
        await refreshMappingData();
      }
      setUpdateTabs?.(prev => !prev);
    } catch (err) {
      console.error(err);
      if (isMounted.current) setErrorData({ title: "Error", message: err.response?.data?.error || err.response?.data?.message || "Failed to create Category" });
    } finally {
      if (isMounted.current) setIsUpdating(false);
    }
  };

  const handleCreateL2 = async () => {
    const finalName = itemName.trim();
    if (!finalName) {
      setErrorData({ title: "Warning", message: "Please enter Note Name" });
      return;
    }
    
    setIsUpdating(true);
    try {
      const returnFormulaItems = selectedItem === "formula"
        ? formulaItems.filter(x => x.value).map(x => ({
            name: typeof x.value === "string" ? x.value : x.value.value ?? x.value.label ?? "",
            sign: x.operator ?? "positive"
          }))
        : [];

      const payload = {
        level: 2,
        levelOneID: activeL1._id,
        item: {
          lineType: selectedItem,
          name: finalName,
          nature: selectedItem === "line item" ? lineItemNature : undefined,
          formula: selectedItem === "formula" ? returnFormulaItems : undefined,
          formulaType: isTotal ? "total" : isSubtotal ? "subtotal" : undefined,
          isBold: isBold || isTotal || isSubtotal,
        }
      };
      
      await axios.post(`/api/v1/populateFS/addGroupingItem?projectID=${project_id}`, payload, { headers });
      if (!isMounted.current) return;
      setSuccessPopupMessage("Note Group created successfully");
      setShowSuccessPopup(true);
      setShowAddL2Modal(false);

      if (refreshMappingData) {
          await refreshMappingData();
       }
       setUpdateTabs?.(prev => !prev);
    } catch (err) {
      console.error(err);
      if (isMounted.current) setErrorData({ title: "Error", message: err.response?.data?.error || err.response?.data?.message || "Failed to create Note Group" });
    } finally {
      if (isMounted.current) setIsUpdating(false);
    }
  };

  const handleCreateL3 = async () => {
    const finalName = itemName.trim();
    if (!finalName) {
      setErrorData({ title: "Warning", message: "Please enter Line Item Name" });
      return;
    }
    
    setIsUpdating(true);
    try {
      const returnFormulaItems = selectedItem === "formula"
        ? formulaItems.filter(x => x.value).map(x => ({
            name: typeof x.value === "string" ? x.value : x.value.value ?? x.value.label ?? "",
            sign: x.operator ?? "positive"
          }))
        : [];

      const payload = {
        level: 3,
        levelOneID: view.level1._id,
        levelTwoID: activeL2._id,
        item: {
          lineType: selectedItem,
          name: finalName,
          nature: selectedItem === "line item" ? lineItemNature : undefined,
          formula: selectedItem === "formula" ? returnFormulaItems : undefined,
          formulaType: isTotal ? "total" : isSubtotal ? "subtotal" : undefined,
          isBold: isBold || isTotal || isSubtotal,
        }
      };
      
      await axios.post(`/api/v1/populateFS/addGroupingItem?projectID=${project_id}`, payload, { headers });
      if (!isMounted.current) return;
      setSuccessPopupMessage("Line Item created successfully");
      setShowSuccessPopup(true);
      setShowAddL3Modal(false);

      if (refreshMappingData) {
        await refreshMappingData();
      }

      setUpdateTabs?.(prev => !prev);
    } catch (err) {
      console.error(err);
      if (isMounted.current) setErrorData({ title: "Error", message: err.response?.data?.error || err.response?.data?.message || "Failed to create Line Item" });
    } finally {
      if (isMounted.current) setIsUpdating(false);
    }
  };

  const handleUpdateGroupingItem = async () => {
    if (!editItemName?.trim()) {
      setErrorData({ title: "Warning", message: "Please enter a name" });
      return;
    }
    
    setIsUpdating(true);
    try {
      const { level, levelOneID, levelTwoID, levelThreeID } = editingItem;

      // Find the old name to see if we need to cascade updates to formulas
      let foundItem = null;
      if (level === 1) {
        foundItem = data.find(x => x._id === levelOneID);
      } else if (level === 2) {
        const l1 = data.find(x => x._id === levelOneID);
        foundItem = l1?.subgroup?.find(x => x._id === levelTwoID);
      } else if (level === 3) {
        const l1 = data.find(x => x._id === levelOneID);
        const l2 = l1?.subgroup?.find(x => x._id === levelTwoID);
        foundItem = l2?.subgroup?.find(x => x._id === levelThreeID);
      }
      const oldName = foundItem?.name;

      const updatesToMake = [];
      if (oldName && oldName.trim() !== editItemName.trim()) {
        const safeOldName = oldName.trim();
        const scanItem = (item, lvl, l1Id, l2Id) => {
          if (item.formula && Array.isArray(item.formula) && item.formula.some(f => f.name && f.name.trim() === safeOldName)) {
            const newFormula = item.formula.map(f => {
              if (f.name && f.name.trim() === safeOldName) {
                return { ...f, name: editItemName };
              }
              return f;
            });
            updatesToMake.push({
              level: lvl,
              levelOneID: l1Id || (lvl === 1 ? item._id : null),
              levelTwoID: l2Id || (lvl === 2 ? item._id : null),
              levelThreeID: lvl === 3 ? item._id : null,
              payload: {
                name: item.name,
                lineType: item.lineType,
                nature: item.nature,
                formula: newFormula,
                formulaType: item.formulaType,
                isBold: item.isBold,
              }
            });
          }
          if (item.subgroup && Array.isArray(item.subgroup) && item.subgroup.length > 0) {
            item.subgroup.forEach(sub => {
              scanItem(sub, lvl + 1, l1Id || item._id, lvl === 1 ? sub._id : l2Id);
            });
          }
        };
        data.forEach(l1 => scanItem(l1, 1, l1._id, null));
      }

      let url = `/api/v1/populateFS/updateGroupingItem?projectID=${project_id}&level=${level}&levelOneID=${levelOneID}`;
      if (level >= 2 && levelTwoID) url += `&levelTwoID=${levelTwoID}`;
      if (level === 3 && levelThreeID) url += `&levelThreeID=${levelThreeID}`;
      
      const returnFormulaItems = editSelectedItem === "formula"
        ? editFormulaItems.filter(x => x.value).map(x => ({
            name: typeof x.value === "string" ? x.value : x.value.label || x.value.value || "",
            sign: x.operator || "positive"
          }))
        : undefined;

      const payload = {
        name: editItemName,
        nature: editSelectedItem === "line item" ? editLineItemNature : undefined,
        lineType: editSelectedItem,
        formula: editSelectedItem === "formula" ? returnFormulaItems : undefined,
        formulaType: editIsTotal ? "total" : editIsSubtotal ? "subtotal" : null,
        isBold: editIsBold || editIsTotal || editIsSubtotal,
      };
      
      await axios.patch(url, payload, { headers });

      // Cascade updates to all dependent formulas
      if (updatesToMake.length > 0) {
        await Promise.allSettled(updatesToMake.map(update => {
          let updateUrl = `/api/v1/populateFS/updateGroupingItem?projectID=${project_id}&level=${update.level}&levelOneID=${update.levelOneID}`;
          if (update.level >= 2 && update.levelTwoID) updateUrl += `&levelTwoID=${update.levelTwoID}`;
          if (update.level === 3 && update.levelThreeID) updateUrl += `&levelThreeID=${update.levelThreeID}`;
          return axios.patch(updateUrl, update.payload, { headers });
        }));
      }

      if (!isMounted.current) return;
      setSuccessPopupMessage("Item updated successfully");
      setShowSuccessPopup(true);
      setEditingItem(null);

       if (refreshMappingData) {
        await refreshMappingData();
      }
      setUpdateTabs?.(prev => !prev);
    } catch (err) {
      console.error(err);
      if (isMounted.current) setErrorData({
        title: "Error",
        message: err.response?.data?.error || err.response?.data?.message || "Failed to update item"
      });
    } finally {
      if (isMounted.current) setIsUpdating(false);
    }
  };

  const handleDeleteGroupingItem = (level, l1Id, l2Id, l3Id) => {
    setDeleteConfirmData({ level, l1Id, l2Id, l3Id });
  };

  const proceedDeleteGroupingItem = async (level, l1Id, l2Id, l3Id) => {
    setIsUpdating(true);
    try {
      // Find the name of the item being deleted so we can cascade the deletion to formulas
      let foundItem = null;
      if (level === 1) {
        foundItem = data.find(x => x._id === l1Id);
      } else if (level === 2) {
        const l1 = data.find(x => x._id === l1Id);
        foundItem = l1?.subgroup?.find(x => x._id === l2Id);
      } else if (level === 3) {
        const l1 = data.find(x => x._id === l1Id);
        const l2 = l1?.subgroup?.find(x => x._id === l2Id);
        foundItem = l2?.subgroup?.find(x => x._id === l3Id);
      }
      const deletedName = foundItem?.name;

      const updatesToMake = [];
      if (deletedName) {
        const safeDeletedName = deletedName.trim();
        const scanItem = (item, lvl, currentL1Id, currentL2Id) => {
          if (item.formula && Array.isArray(item.formula) && item.formula.some(f => f.name && f.name.trim() === safeDeletedName)) {
            const newFormula = item.formula.filter(f => !(f.name && f.name.trim() === safeDeletedName));
            updatesToMake.push({
              level: lvl,
              levelOneID: currentL1Id || (lvl === 1 ? item._id : null),
              levelTwoID: currentL2Id || (lvl === 2 ? item._id : null),
              levelThreeID: lvl === 3 ? item._id : null,
              payload: {
                name: item.name,
                lineType: item.lineType,
                nature: item.nature,
                formula: newFormula,
                formulaType: item.formulaType,
                isBold: item.isBold,
              }
            });
          }
          if (item.subgroup && Array.isArray(item.subgroup) && item.subgroup.length > 0) {
            item.subgroup.forEach(sub => {
              scanItem(sub, lvl + 1, currentL1Id || item._id, lvl === 1 ? sub._id : currentL2Id);
            });
          }
        };
        data.forEach(l1 => scanItem(l1, 1, l1._id, null));
      }

      let url = `/api/v1/populateFS/deleteGroupingItem?projectID=${project_id}&level=${level}&levelOneID=${l1Id}`;
      if (level >= 2 && l2Id) url += `&levelTwoID=${l2Id}`;
      if (level === 3 && l3Id) url += `&levelThreeID=${l3Id}`;
      
      await axios.delete(url, { headers });

      // Cascade deletes to all dependent formulas
      if (updatesToMake.length > 0) {
        await Promise.allSettled(updatesToMake.map(update => {
          let updateUrl = `/api/v1/populateFS/updateGroupingItem?projectID=${project_id}&level=${update.level}&levelOneID=${update.levelOneID}`;
          if (update.level >= 2 && update.levelTwoID) updateUrl += `&levelTwoID=${update.levelTwoID}`;
          if (update.level === 3 && update.levelThreeID) updateUrl += `&levelThreeID=${update.levelThreeID}`;
          return axios.patch(updateUrl, update.payload, { headers });
        }));
      }

      if (!isMounted.current) return;
      setSuccessPopupMessage("Item deleted successfully");
      setShowSuccessPopup(true);

      if (refreshMappingData) {
        await refreshMappingData();
      }
      setUpdateTabs?.(prev => !prev);
      window.dispatchEvent(new CustomEvent('groupingItemDeleted'));
              
      if (level === 2 && view.type === "detail" && view.level2?._id === l2Id) {
          handleBackToRoot();
      }
    } catch (err) {
      console.error(err);
      if (isMounted.current) setErrorData({
        title: "Error",
        message: err.response?.data?.error || err.response?.data?.message || "Failed to delete item"
      });
    } finally {
      if (isMounted.current) setIsUpdating(false);
    }
  };

  // Clear any legacy grouping cache so backend remains single source of truth
  useEffect(() => {
    sessionStorage.removeItem("bsGroupingData");
    sessionStorage.removeItem("plGroupingData");
    sessionStorage.removeItem("groupingData");
  }, []);
  
  // View states and hooks moved to top
  const internalContainerRef = useRef(null);
  const tableContainerRef = internalContainerRef; // Fixed: Do not use containerRef directly as it is overwritten by parent div
  const highlightedRowRef = useRef(null);
  const l3DragScrollRef = useRef(null);    // Saved scroll position during/after L3 drag
  const isDraggingL3Ref = useRef(false);   // True only while actively dragging (cleared on dragend)

  // TEMP: confirm new code is compiled and running
  useEffect(() => { console.log("[L3-DEBUG-MOUNT] NEW CODE RUNNING"); }, []);

  useEffect(() => {
    // When grouping data updates (e.g. after a drop), refresh the data in the current view
    if (internalView.type === "detail" && internalView.level1 && internalView.level2) {
      const freshL1 = grouping.find(l1 => l1._id === internalView.level1._id);
      const freshL2 = freshL1?.subgroup?.find(l2 => l2._id === internalView.level2._id);
      
      if (freshL1 && freshL2) {
        setInternalView(prev => ({
          ...prev,
          level1: freshL1,
          level2: freshL2
        }));
      }
    }
  }, [grouping]);

  useEffect(() => {
    // Restore scroll position whenever we return to the root view
    if (view.type === "root" && tableContainerRef.current) {
      const savedScroll = sessionStorage.getItem("scrollPosition");
      if (savedScroll) {
        // Use a small timeout to ensure DOM has rendered
        setTimeout(() => {
          if (tableContainerRef.current) {
            tableContainerRef.current.scrollTop = parseInt(savedScroll);
          }
        }, 100);
      }
    }
  }, [view.type]);

  useEffect(() => {
    setData(grouping || []);
    ignoreScrollResetsRef.current = true;
    if (ignoreScrollTimeoutRef.current) clearTimeout(ignoreScrollTimeoutRef.current);
    ignoreScrollTimeoutRef.current = setTimeout(() => {
      ignoreScrollResetsRef.current = false;
    }, 500);
  }, [grouping]);

  useEffect(() => {
    if (isUpdating) {
      ignoreScrollResetsRef.current = true;
    } else {
      if (ignoreScrollTimeoutRef.current) clearTimeout(ignoreScrollTimeoutRef.current);
      ignoreScrollTimeoutRef.current = setTimeout(() => {
        ignoreScrollResetsRef.current = false;
      }, 500);
    }
  }, [isUpdating]);

  useLayoutEffect(() => {
    if (tableContainerRef.current) {
      if (tableContainerRef.current.scrollTop !== lastScrollPosRef.current) {
        skipNextScrollEvent.current = true;
        tableContainerRef.current.scrollTop = lastScrollPosRef.current;
      }
    }
  });

  useEffect(() => {
    const handleDrilldownNavigate = (e) => {
      if (e.detail && e.detail.fs_grp && e.detail.note_grp) {
        const { fs_grp, note_grp } = e.detail;
        const l1 = data.find((l) => l.name === fs_grp || l.fs_grp === fs_grp);
        if (l1) {
          const l2 = l1.subgroup?.find((s) => s.name === note_grp || s.notes_grp === note_grp);
          if (l2) {
            const newView = { type: "detail", level1: l1, level2: l2 };
            sessionStorage.setItem("view", JSON.stringify(newView));
            setView(newView);
            lastScrollPosRef.current = 0;
            sessionStorage.setItem("l3DragScroll", 0);
          }
        }
      }
    };
    window.addEventListener("drilldown_navigate", handleDrilldownNavigate);
    return () => window.removeEventListener("drilldown_navigate", handleDrilldownNavigate);
  }, [data]);


  useEffect(() => {
    const savedView = sessionStorage.getItem("view");
    if (savedView) {
      try {
        setInternalView(JSON.parse(savedView));
      } catch (err) {
        console.error("Error parsing saved view:", err);
      }
    }
  }, []);

  const { level1, level2 } = view;

  useEffect(() => {
    if (level2) {
      const foundL2 = data
        .find((l1) => l1._id === level1?._id)
        ?.subgroup?.find((s) => s._id === level2?._id);
      
      // Always update to the found L2, or keep level2 if not found
      setUpdatedL2(foundL2 || level2);
    } else {
      setUpdatedL2([]);
    }
  }, [data, level1, level2]);

  const addFormulaItem = () => {
    setFormulaItems((prev) => [
      ...prev,
      {
        element: Date.now() + Math.floor(Math.random() * 1000),
        value: "",
        operator: pendingOperator,
      },
    ]);
  };

  const updateFormulaItem = (index, value) => {
    setFormulaItems((prev) => {
      const copy = [...prev];
      copy[index] = { ...copy[index], value };
      return copy;
    });
  };

  const updateFormulaOperator = (index, operator) => {
    setFormulaItems((prev) => {
      const copy = [...prev];
      copy[index] = { ...copy[index], operator };
      return copy;
    });
  };

  const formulaDisplayString = (() => {
    if (!formulaItems || formulaItems.length === 0) return "";
    const pieces = formulaItems.map((it) => {
      if (!it || !it.value) return "(?)";
      if (typeof it.value === "string") return it.value;
      if (it.value.label) return it.value.label;
      return it.value.value ?? "(?)";
    });
    let display = pieces[0] || "";
    for (let i = 1; i < pieces.length; i++) {
      const op = operatorOptions.find(
        (o) => o.value === formulaItems[i].operator
      );
      display += ` (${op?.symbol ?? "+"}) ${pieces[i]}`;
    }
    return display;
  })();

  const prevSelection = useRef({ l1: null, l2: null });

  useEffect(() => {
    // Only update view from props if they are non-null AND different from current selection
    if (selectedL1 && selectedL2) {
      const isSame = view.level1?._id === selectedL1._id && view.level2?._id === selectedL2._id;
      if (!isSame) {
        const newView = { type: "detail", level1: selectedL1, level2: selectedL2 };
        sessionStorage.setItem("view", JSON.stringify(newView));
        setHighlightedNoteId(selectedL2._id);
        setView(newView);
      }
      prevSelection.current = { l1: selectedL1, l2: selectedL2 };
    } else if (selectedL1 === null && selectedL2 === null && view.type === "detail") {
      // Only reset if the selection was explicitly cleared (e.g. via dropdown reset)
      if (prevSelection.current.l1 || prevSelection.current.l2) {
        const rootView = { type: "root", level1: null, level2: null };
        sessionStorage.setItem("view", JSON.stringify(rootView));
        setView(rootView);
      }
      prevSelection.current = { l1: null, l2: null };
    }
  }, [selectedL1, selectedL2]);


  // parse payload helper
  const getParsedPayloadFromEvent = (e) => {
    try {
      const json = e.dataTransfer.getData("application/json");
      if (json) {
        try {
          return JSON.parse(json);
        } catch {
          return json;
        }
      }
    } catch (err) {
      // ignore
    }
    try {
      const txt = e.dataTransfer.getData("text/plain");
      if (txt) {
        try {
          return JSON.parse(txt);
        } catch {
          return txt;
        }
      }
    } catch (err) {
      // ignore
    }
    // fallback for your global approach (if used)
    if (typeof window !== "undefined" && window.__MY_APP_DRAG_PAYLOAD) {
      return window.__MY_APP_DRAG_PAYLOAD;
    }
    return null;
  };

  // flexible extractor for cy/py fields
  const extractCyPyFromItem = (item) => {
    if (!item) return { cy: null, py: null };
    if (typeof item.cy !== "undefined" || typeof item.py !== "undefined") {
      return { cy: item.cy ?? null, py: item.py ?? null };
    }
    if (
      typeof item.currentYear !== "undefined" ||
      typeof item.previousYear !== "undefined"
    ) {
      return { cy: item.currentYear ?? null, py: item.previousYear ?? null };
    }
    if (
      typeof item.current_year !== "undefined" ||
      typeof item.previous_year !== "undefined"
    ) {
      return { cy: item.current_year ?? null, py: item.previous_year ?? null };
    }
    return { cy: null, py: null };
  };

  const createEmptyRow = () => ({
    _id: Math.random().toString(36).slice(2),
    name: "",
    currentYear: "",
    previousYear: "",
    subgroup: [],
    isNewRow: true,
  });

  const handleAddLevel2 = (l1Id) => {
    const updated = data.map((l1) => {
      if (l1._id !== l1Id) return l1;

      return {
        ...l1,
        subgroup: [...(l1.subgroup || []), createEmptyRow()],
      };
    });

    setData(updated);
  };

  const handleAddLevel3 = (l1Id, l2Id) => {
    const updated = data.map((l1) => {
      if (l1._id !== l1Id) return l1;

      return {
        ...l1,
        subgroup: l1.subgroup.map((l2) => {
          if (l2._id !== l2Id) return l2;

          return {
            ...l2,
            subgroup: [...(l2.subgroup || []), createEmptyRow()],
          };
        }),
      };
    });

    setData(updated);
  };

  // Hovered state moved to top
  
  // Helper to find updatedL2 (so updated values are reflected when drilling down)

  // const handleNoteClick = (level1, level2) => {
  //   // Save the current scroll position before navigating
  //   if (tableContainerRef.current) {
  //     setScrollPosition(tableContainerRef.current.scrollTop);
  //   }
  //   setHighlightedNoteId(level2._id);
  //   setView({ type: "detail", level1, level2 });
  // };

  const handleNoteClick = (level1, level2) => {
    // Save the current scroll position before navigating
    if (tableContainerRef.current) {
      sessionStorage.setItem("scrollPosition", tableContainerRef.current.scrollTop);
    }
    const newView = { type: "detail", level1, level2 };
    sessionStorage.setItem("highlightedNoteId", level2._id);
    sessionStorage.setItem("view", JSON.stringify(newView));
    setHighlightedNoteId(level2._id);
    setView(newView);
    lastScrollPosRef.current = 0;
    sessionStorage.setItem("l3DragScroll", 0);
  };

  const handleBackToRoot = () => {
    const savedHighlightId = sessionStorage.getItem("highlightedNoteId");
    sessionStorage.removeItem("highlightedNoteId");
    sessionStorage.setItem("view", JSON.stringify({ type: "root", level1: null, level2: null }));
    setHighlightedNoteId(savedHighlightId);
    setView({ type: "root", level1: null, level2: null });
    
    // Notify parent to clear its selection state
    setExternalSelection?.(null, null);
    
    // Refresh parent data to ensure root view totals are correct
    setUpdateTabs?.(prev => !prev);

    const savedScroll = parseInt(sessionStorage.getItem("scrollPosition") || "0", 10);
    lastScrollPosRef.current = savedScroll;
    sessionStorage.setItem("l3DragScroll", savedScroll);

    setTimeout(() => {
      if (highlightedRowRef.current) {
        highlightedRowRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 100);
  };

  const determineDroppedSign = (droppedValue, l1, l2, l3 = null) => {
    if (droppedValue === 0) return 0;
    const isNegativeNature = 
      (l3 && (l3.currentYear < 0 || l3.previousYear < 0)) ||
      (l2 && (l2.currentYear < 0 || l2.previousYear < 0)) ||
      (l1 && (l1.currentYear < 0 || l1.previousYear < 0));
    if (isNegativeNature) {
      return -Math.abs(droppedValue);
    }
    return Math.abs(droppedValue);
  };

  // drop handlers
  const onLevel3DragOver = (e) => {
    e.preventDefault(); 
  };

  const onLevel3Drop = (l3Row, toIndex) => async (e) => {
    e.preventDefault();
    e.stopPropagation();

    setDraggingL3Id(null);

    if (tableContainerRef.current) {
      l3DragScrollRef.current = tableContainerRef.current.scrollTop;
    }

    let optimisticGrouping = null;
    try {
      const parsed = getParsedPayloadFromEvent(e);
      if (parsed?.type === "reorderL3") {
        const savedScroll = l3DragScrollRef.current; 
        const { l1Id, l2Id, fromIndex } = parsed;

        if (fromIndex === toIndex) return;

        setData((prevData) =>
          prevData.map((l1) => {
            if (l1._id !== l1Id) return l1;
            return {
              ...l1,
              subgroup: l1.subgroup.map((l2) => {
                if (l2._id !== l2Id) return l2;
                return {
                  ...l2,
                  subgroup: moveItem(l2.subgroup, fromIndex, toIndex),
                };
              }),
            };
          })
        );

        await handleReorderL3(l1Id, l2Id, fromIndex, toIndex);
        if (!isMounted.current) return;

        if (refreshMappingData) {
          await refreshMappingData();
        }
        if (!isMounted.current) return;
        if (typeof onAfterDrop === 'function') onAfterDrop();

        if (savedScroll !== null && tableContainerRef.current) {
          setTimeout(() => {
            if (tableContainerRef.current) {
              tableContainerRef.current.scrollTop = savedScroll;
            }
          }, 50);
        }
        return;
      }

      // resolve all items from payload
      const droppedItems = Array.isArray(parsed) 
        ? parsed 
        : (parsed.items || [parsed.item || parsed]);

      let targetColumn = null;
      const targetTd = e.target.closest("td");
      if (targetTd) {
        const cells = Array.from(targetTd.parentNode.children);
        const tdIndex = cells.indexOf(targetTd);
        if (tdIndex === 1) targetColumn = "cy";
        else if (tdIndex === 2) targetColumn = "py";
      }

      const draggedColumn = targetColumn || parsed.draggedColumn || "cy";

      let droppedCy = 0;
      let droppedPy = 0;

      droppedItems.forEach(item => {
        const { cy, py } = extractCyPyFromItem(item);
        droppedCy += convertStrToNumber(String(cy || 0));
        droppedPy += convertStrToNumber(String(py || 0));
      });

      // Find parent l1 and l2 to determine the sign nature
      // NEW — use the currently open view instead
      const targetL1Id = level1?._id;
      const targetL2Id = updatedL2?._id;
      let targetL1 = data.find(l1 => l1._id === targetL1Id);
      let targetL2 = targetL1?.subgroup?.find(l2 => l2._id === targetL2Id);

      droppedCy = determineDroppedSign(droppedCy, targetL1, targetL2, l3Row);
      droppedPy = determineDroppedSign(droppedPy, targetL1, targetL2, l3Row);

      // immutably update the specific level-3 row and its parents
      const updatedGrouping = data.map((l1) => {
        if (!Array.isArray(l1.subgroup)) return l1;
        
        let l1Updated = false;
        const updatedSubgroups = l1.subgroup.map((l2) => {
          if (!Array.isArray(l2.subgroup)) return l2;

          let l2Updated = false;
          const updatedL3Rows = l2.subgroup.map((l3, idx) => {
          if (idx === toIndex) {
              l2Updated = true;
              l1Updated = true;
              
              if (checkYearly) {
                if (draggedColumn === "cy") {
                  return {
                    ...l3,
                    currentYear: droppedCy,
                  };
                } else {
                  return {
                    ...l3,
                    previousYear: droppedPy,
                  };
                }
              } else {
                return {
                  ...l3,
                  currentYear: droppedCy,
                  previousYear: droppedPy,
                };
              }
            }
            return l3;
          });

          if (l2Updated) {
            // Recalculate L2 totals based on new L3 values
            const newL2Cy = updatedL3Rows.reduce((sum, r) => sum + convertStrToNumber(String(r.currentYear || 0)), 0);
            const newL2Py = updatedL3Rows.reduce((sum, r) => sum + convertStrToNumber(String(r.previousYear || 0)), 0);
            return { ...l2, subgroup: updatedL3Rows, currentYear: newL2Cy, previousYear: newL2Py };
          }
          return l2;
        });

        if (l1Updated) {
          // Recalculate L1 totals based on new L2 values
          const newL1Cy = updatedSubgroups.reduce((sum, r) => sum + convertStrToNumber(String(r.currentYear || 0)), 0);
          const newL1Py = updatedSubgroups.reduce((sum, r) => sum + convertStrToNumber(String(r.previousYear || 0)), 0);
          return { ...l1, subgroup: updatedSubgroups, currentYear: newL1Cy, previousYear: newL1Py };
        }
        return l1;
      });

      // Update the visible table immediately; the server save happens in the background.
      optimisticGrouping = updatedGrouping;
      setData(updatedGrouping);

      const updatedL2Item = updatedGrouping
        .find(l1 => l1._id === view.level1?._id)
        ?.subgroup?.find(l2 => l2._id === view.level2?._id);
      if (updatedL2Item) setUpdatedL2(updatedL2Item);

      // Persist the mapping without blocking or blurring the table.
      if (droppedItems && droppedItems.length > 0) {
        // targetL1 / targetL2 already computed above (via level1/updatedL2) — reuse them
        if (targetL1 && targetL2) {
          const updatedData = droppedItems.map(item => {
            const dragItem = item?.item_ || item;
            let finalMapData = {};

            if (checkYearly) {
              if (draggedColumn === "cy") {
                finalMapData = {
                  cy_map: { fs_grp: targetL1.name, note_grp: targetL2.name, note_no: targetL2.notes, sub_grp: l3Row.name },
                  py_map: dragItem.map_data?.py_map || {
                    fs_grp: dragItem.fs_grp || "",
                    note_grp: dragItem.note_grp || "",
                    note_no: dragItem.note_no || "",
                    sub_grp: dragItem.sub_grp || ""
                  }
                };
              } else { // draggedColumn === "py"
                finalMapData = {
                  cy_map: dragItem.map_data?.cy_map || {
                    fs_grp: dragItem.fs_grp || "",
                    note_grp: dragItem.note_grp || "",
                    note_no: dragItem.note_no || "",
                    sub_grp: dragItem.sub_grp || ""
                  },
                  py_map: { fs_grp: targetL1.name, note_grp: targetL2.name, note_no: targetL2.notes, sub_grp: l3Row.name }
                };
              }
            } else {
              finalMapData = {
                cy_map: { fs_grp: targetL1.name, note_grp: targetL2.name, note_no: targetL2.notes, sub_grp: l3Row.name },
                py_map: { fs_grp: targetL1.name, note_grp: targetL2.name, note_no: targetL2.notes, sub_grp: l3Row.name }
              };
            }

            const currentYearMap = finalMapData.cy_map || {
              fs_grp: dragItem.fs_grp || "",
              note_grp: dragItem.note_grp || "",
              note_no: dragItem.note_no || "",
              sub_grp: dragItem.sub_grp || ""
            };

            return {
              ...dragItem,
              fs_grp: currentYearMap.fs_grp,
              note_grp: currentYearMap.note_grp,
              note_no: currentYearMap.note_no,
              sub_grp: currentYearMap.sub_grp,
              map_data: finalMapData
            };
          });

          const saveResponse = await dispatch(batchUpdateConventionalMode(conventionModeData.set_payload, updatedData, updatedData));
          if (!saveResponse) {
            setData(data);
            setUpdatedL2(updatedL2);
            optimisticGrouping = null;
            return;
          }
          if (!isMounted.current) return;
          if (typeof onAfterDrop === 'function') await onAfterDrop(droppedItems?.length || 1);
        }
      }

      if (!isMounted.current) return;
    } catch (error) {
      console.error("Error during drop operation:", error);
      if (optimisticGrouping) {
        setData(data);
        setUpdatedL2(updatedL2);
      }
    }
  };

  const onLevel3DragEnter = (id) => (e) => {
    e.preventDefault();
  };
  const onLevel3DragLeave = (id) => (e) => {
    e.preventDefault();
  };

  const logReorderContext = ({
    parent,
    child,
    fromIndex,
    toIndex,
    fullPath,
  }) => {
    console.log("update sequence:", {
      previous: {
        index: fromIndex,
        parentId: parent._id,
        parentName: parent.name,
      },
      current: {
        index: toIndex,
        parentId: parent._id,
        parentName: parent.name,
      },
      movedItem: {
        childId: child._id,
        childName: child.name,
      },
      hierarchy: fullPath, // full ancestry
    });
  };

  const moveItem = (arr, fromIndex, toIndex) => {
    const copy = [...arr];
    const [moved] = copy.splice(fromIndex, 1);
    copy.splice(toIndex, 0, moved);
    return copy;
  };

const rearrangeGroupingItem = async ({
  level,
  levelOneID,
  levelTwoID,
  fromIndex,
  toIndex,
}) => {
  try {
    const payload = {
      level,
      levelOneID,
      fromIndex,
      toIndex,
    };

    if (level === 3) {
      payload.levelTwoID = levelTwoID;
    }

    await axios.put(
      `/api/v1/populateFS/rearrangeGroupingItem?projectID=${project_id}`,
      payload,
      { headers }
    );



  } catch (err) {
    console.error("Rearrange API Error:", err);

    setErrorData({
      title: "Error",
      message: err.response?.data?.error || err.response?.data?.message || "Failed to rearrange item"
    });
  }
};

const handleReorderL2 = async (l1Id, fromIndex, toIndex) => {
  if (fromIndex === toIndex) return;

  await rearrangeGroupingItem({
    level: 2,
    levelOneID: l1Id,
    fromIndex,
    toIndex,
  });
};

const handleReorderL3 = async (
  l1Id,
  l2Id,
  fromIndex,
  toIndex
) => {
  if (fromIndex === toIndex) return;

  await rearrangeGroupingItem({
    level: 3,
    levelOneID: l1Id,
    levelTwoID: l2Id,
    fromIndex,
    toIndex,
  });
};

  if (view.type === "root") {
    return (
      <div style={{ position: "relative", flex: 1, height: "100%", border: "1px solid #ddd", borderRadius: "15px", backgroundColor: "#fff", overflow: "hidden", margin: "2px", width: "calc(100% - 4px)" }}>
        <div style={{ filter: isUpdating ? "blur(3px)" : "none", transition: "filter 0.2s ease", height: "100%" }}>
          <div
            ref={tableContainerRef}
            id="TemplateScroll"
            className="hide-scrollbar"
            style={{ height: "100%", overflow: "auto", paddingBottom: "20px" }}
            onScroll={(e) => {
              const newScroll = e.currentTarget.scrollTop;
              if (skipNextScrollEvent.current) {
                skipNextScrollEvent.current = false;
                return;
              }
              if (ignoreScrollResetsRef.current) {
                if (newScroll !== lastScrollPosRef.current) {
                  e.currentTarget.scrollTop = lastScrollPosRef.current;
                }
                return;
              }
              lastScrollPosRef.current = newScroll;
              sessionStorage.setItem("l3DragScroll", newScroll);
            }}
          >
            <table
              className={`${tablecss.customTable} ${tablecss.stickyTable}`}
              style={{ minWidth: "100%", borderCollapse: "separate", borderSpacing: 0, tableLayout: "auto" }}
            >
              <thead>
                <tr>
                  <th className={`text-left`} style={{ position: "sticky", top: "0px", zIndex: 5, padding: "18px 8px 18px 15px", minWidth: "250px", backgroundColor: "#fff" }}>
                    Particulars
                  </th>
                  <th className={`text-center`} style={{ position: "sticky", top: "0px", zIndex: 5, padding: "15px 8px", minWidth: "60px", backgroundColor: "#fff" }}>
                    Note
                  </th>
                  <th className={`text-right`} style={{ position: "sticky", top: "0px", zIndex: 5, padding: "15px 8px", minWidth: "100px", backgroundColor: "#fff" }}>
                    {currentYearLabel}
                  </th>
                  <th className={`text-right`} style={{ position: "sticky", top: "0px", zIndex: 5, padding: "15px 8px", minWidth: "100px", backgroundColor: "#fff" }}>
                    {previousYearLabel}
                  </th>
                  <th className={`text-center`} style={{ position: "sticky", top: "0px", zIndex: 5, padding: "15px 2px", width: "60px", backgroundColor: "#fff" }}>
                    
                  </th>
                </tr>
              </thead>
              <tbody
                style={{
                  background: `${theme ? "" : "#363535"}`,
                  color: `${theme ? "" : "#fff"}`,
                }}
              >
                <tr className={`text-left pl-3`} style={{ borderBottom: "none" }}>
                  <td
                    colSpan={5}
                    style={{
                      padding: "8px 8px 8px 24px",
                      borderBottom: "none",
                      textAlign: "right"
                    }}
                  >
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setItemName("");
                        setSelectedItem("line item");
                        setLineItemNature("credit");
                        setFormulaItems([{ element: Date.now(), value: "", operator: "positive" }]);
                        setPendingOperator("positive");
                        setShowAddL1Modal(true);
                      }}
                      style={{
                        border: "none",
                        background: "transparent",
                        color: "#2D8861",
                        cursor: "pointer",
                        fontWeight: 500,
                        fontSize: "14px",
                        display: "inline-flex",
                        alignItems: "center",
                        marginRight: "16px"
                      }}
                    >
                      <AddIcon width={16} height={16} style={{ marginTop: "-2px", marginRight: "4px"}}/>
                      Add Level 1 Note Group
                    </button>
                  </td>
                </tr>

                {data.map((l1, l1Index) => (
                  <React.Fragment key={l1._id}>
                    <tr
                      className="text-left pl-3"
                      style={{
                        paddingTop: "5px",
                        paddingBottom: "5px",
                      }}
                      onMouseEnter={() => setHoveredL1Id(l1._id)}
                      onMouseLeave={() => setHoveredL1Id(null)}
                    >
                      <td
                        className={`text-left ${commoncss.fs14} ${commoncss.fw600}`}
                        style={{
                          padding: "8px 8px 8px 15px",
                          borderBottom: "0.5px solid transparent",
                          backgroundColor: hoveredL1Id === l1._id ? "#e8f6ed" : "#eff7f0",
                          transition: "background-color 0.2s ease",
                        }}
                      >
                        {l1.name}
                      </td>
                      <td
                        style={{
                          borderBottom: "0.5px solid transparent",
                          padding: "8px",
                          textAlign: "center",
                          fontWeight: 600,
                          backgroundColor: hoveredL1Id === l1._id ? "#e8f6ed" : "#eff7f0",
                          transition: "background-color 0.2s ease",
                        }}
                      >
                      </td>
                      <td
                        className="text-right"
                        style={{
                          borderBottom: "0.5px solid transparent",
                          padding: "8px",
                          fontWeight: 600,
                          backgroundColor: hoveredL1Id === l1._id ? "#e8f6ed" : "#eff7f0",
                          transition: "background-color 0.2s ease",
                        }}
                      >
                        {isStandaloneLevel1(l1) && l1.lineType === "formula" && hasDisplayValue(l1.currentYear)
                          ? formatIndianCurrency(Math.round(Number(l1.currentYear ?? 0)))
                          : ""}
                      </td>
                      <td
                        className="text-right"
                        style={{
                          borderBottom: "0.5px solid transparent",
                          padding: "8px",
                          fontWeight: 600,
                          backgroundColor: hoveredL1Id === l1._id ? "#e8f6ed" : "#eff7f0",
                          transition: "background-color 0.2s ease",
                        }}
                      >
                        {isStandaloneLevel1(l1) && l1.lineType === "formula" && hasDisplayValue(l1.previousYear)
                          ? formatIndianCurrency(Math.round(Number(l1.previousYear ?? 0)))
                          : ""}
                      </td>
                      <td
                        className="text-center"
                        style={{
                          borderBottom: "0.5px solid transparent",
                          padding: "8px 2px",
                          width: "60px",
                          backgroundColor: hoveredL1Id === l1._id ? "#e8f6ed" : "#eff7f0",
                          transition: "background-color 0.2s ease",
                        }}
                      >
                        {hoveredL1Id === l1._id && !l1.isNewRow && (
                          <span style={{ display: 'inline-flex', gap: '6px', verticalAlign: 'middle' }}>
                            <button
                              style={{ border: 'none', background: 'transparent', cursor: 'pointer', padding: 2, color: '#4CAF50', display: 'inline-flex', alignItems: 'center' }}
                              onClick={(e) => {
                                e.stopPropagation();
                                setEditingItem({ level: 1, levelOneID: l1._id, name: l1.name });
                              }}
                            >
                              <EditIcon width={16} height={16} />
                            </button>
                            <button
                              style={{ border: 'none', background: 'transparent', cursor: 'pointer', padding: 2, color: '#F44336', display: 'inline-flex', alignItems: 'center' }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteGroupingItem(1, l1._id);
                              }}
                            >
                              <DeleteIcon width={16} height={16} />
                            </button>
                          </span>
                        )}
                      </td>
                    </tr>

                    {(l1.subgroup || []).map((l2, l2Index) => {
                      const isL2Bold = !!(l2.isBold || l2.isTotal || l2.isSubtotal || l2.formulaType === "total" || l2.formulaType === "subtotal");
                      const isDragging = draggingL2Id === l2._id;

                      const rowDraggingStyle = isDragging ? {
                        backgroundColor: "#fff",
                        boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
                        zIndex: 9999,
                        position: "relative",
                      } : {};

                      return (
                        <tr
                          className={commoncss.dataGrab}
                          key={l2._id}
                          draggable
                          onMouseEnter={() => setHoveredL2Id(l2._id)}
                          onMouseLeave={() => setHoveredL2Id(null)}
                          onMouseDown={() => {
                            const scroll = tableContainerRef.current?.scrollTop;
                            l2DragScrollRef.current = scroll ?? null;
                          }}
                          onDragStart={(e) => {
                            setDraggingL2Id(l2._id);
                            const scroll = tableContainerRef.current?.scrollTop;
                            if (scroll !== undefined && scroll !== null) {
                              l2DragScrollRef.current = scroll;
                            }
                            e.dataTransfer.setData(
                              "text/plain",
                              JSON.stringify({
                                type: "reorderL2",
                                l1Id: l1._id,
                                fromIndex: l2Index,
                              })
                            );
                          }}
                          onDragEnd={() => {
                            setDraggingL2Id(null);
                          }}
                          onDragOver={(e) => {
                            if (window.__MY_APP_DRAG_PAYLOAD?.type === "conventionalRow") {
                              return;
                            }
                            e.preventDefault();
                          }}
                          onDrop={async (e) => {
                            e.preventDefault();
                            setDraggingL2Id(null);

                            if (tableContainerRef.current) {
                              l2DragScrollRef.current = tableContainerRef.current.scrollTop;
                            }

                            const payload = getParsedPayloadFromEvent(e);
                            if (!payload) return;

                            if (payload.type === "reorderL2" || (payload.l1Id && payload.fromIndex !== undefined && !payload.items && payload.type !== "conventionalRow" && payload.type !== "reorderL3")) {
                              const savedScroll = l2DragScrollRef.current ?? tableContainerRef.current?.scrollTop;
                              const { l1Id, fromIndex } = payload;
                              const toIndex = l2Index;

                              if (fromIndex === toIndex || l1Id !== l1._id) return;

                              setData((prevData) =>
                                prevData.map((l1Item) => {
                                  if (l1Item._id !== l1Id) return l1Item;
                                  return {
                                    ...l1Item,
                                    subgroup: moveItem(l1Item.subgroup, fromIndex, toIndex),
                                  };
                                })
                              );

                              await handleReorderL2(l1Id, fromIndex, toIndex);
                              if (!isMounted.current) return;

                              if (refreshMappingData) {
                                await refreshMappingData();
                              }
                              if (!isMounted.current) return;
                              if (typeof onAfterDrop === 'function') onAfterDrop();
                              setUpdateTabs?.((prev) => !prev);

                              if (savedScroll !== null && tableContainerRef.current) {
                                setTimeout(() => {
                                  if (tableContainerRef.current) {
                                    tableContainerRef.current.scrollTop = savedScroll;
                                  }
                                }, 50);
                              }
                              return;
                            }

                            //   if (payload.type === "conventionalRow" || payload.items) {
                            //   const droppedItems = Array.isArray(payload) ? payload : (payload.items || [payload.item || payload]);
                              
                            //   let targetColumn = null;
                            //   const targetTd = e.target.closest("td");
                            //   if (targetTd) {
                            //     const cells = Array.from(targetTd.parentNode.children);
                            //     const tdIndex = cells.indexOf(targetTd);
                            //     if (tdIndex === 2) targetColumn = "cy";
                            //     else if (tdIndex === 3) targetColumn = "py";
                            //   }

                            //   const draggedColumn = targetColumn || payload.draggedColumn || "cy";

                            //   let droppedCy = 0;
                            //   let droppedPy = 0;
                            //   droppedItems.forEach(item => {
                            //     const { cy, py } = extractCyPyFromItem(item);
                            //     droppedCy += convertStrToNumber(String(cy || 0));
                            //     droppedPy += convertStrToNumber(String(py || 0));
                            //   });

                            //   droppedCy = determineDroppedSign(droppedCy, l1, l2, null);
                            //   droppedPy = determineDroppedSign(droppedPy, l1, l2, null);

                            //   const isBsTable = data && data[0]?.category === "BS";

                            //   const updatedGrouping = data.map(l1item => {
                            //     if (l1item._id !== l1._id) return l1item;

                            //     const updatedSubgroups = l1item.subgroup.map(l2item => {
                            //       if (l2item._id === l2._id) {
                            //         if (isBsTable) {
                            //           let newL3Subgroup = l2item.subgroup || [];
                            //           if (newL3Subgroup.length > 0) {
                            //             newL3Subgroup = newL3Subgroup.map((l3item, idx) => {
                            //               if (idx === 0) {
                            //                 if (checkYearly) {
                            //                   if (draggedColumn === "cy") {
                            //                     return {
                            //                       ...l3item,
                            //                       currentYear: droppedCy,
                            //                     };
                            //                   } else {
                            //                     return {
                            //                       ...l3item,
                            //                       previousYear: droppedPy,
                            //                     };
                            //                   }
                            //                 } else {
                            //                   return {
                            //                     ...l3item,
                            //                     currentYear: droppedCy,
                            //                     previousYear: droppedPy,
                            //                   };
                            //                 }
                            //               }
                            //               return l3item;
                            //             });
                            //           }

                            //           const newL2Cy = newL3Subgroup.length > 0
                            //             ? newL3Subgroup.reduce((sum, r) => sum + convertStrToNumber(String(r.currentYear || 0)), 0)
                            //             : (checkYearly && draggedColumn === "py" ? l2item.currentYear : droppedCy);

                            //           const newL2Py = newL3Subgroup.length > 0
                            //             ? newL3Subgroup.reduce((sum, r) => sum + convertStrToNumber(String(r.previousYear || 0)), 0)
                            //             : (checkYearly && draggedColumn === "cy" ? l2item.previousYear : droppedPy);

                            //           return {
                            //             ...l2item,
                            //             subgroup: newL3Subgroup,
                            //             currentYear: newL2Cy,
                            //             previousYear: newL2Py,
                            //           };
                            //         } else {
                            //           // Original logic for P&L / non-BS
                            //           if (checkYearly) {
                            //             if (draggedColumn === "cy") {
                            //               return {
                            //                 ...l2item,
                            //                 currentYear: droppedCy,
                            //               };
                            //             } else {
                            //               return {
                            //                 ...l2item,
                            //                 previousYear: droppedPy,
                            //               };
                            //             }
                            //           } else {
                            //             return {
                            //               ...l2item,
                            //               currentYear: droppedCy,
                            //               previousYear: droppedPy,
                            //             };
                            //           }
                            //         }
                            //       }
                            //       return l2item;
                            //     });

                            //     const newL1Cy = updatedSubgroups.reduce((sum, r) => sum + convertStrToNumber(String(r.currentYear || 0)), 0);
                            //     const newL1Py = updatedSubgroups.reduce((sum, r) => sum + convertStrToNumber(String(r.previousYear || 0)), 0);
                            //     return { ...l1item, subgroup: updatedSubgroups, currentYear: newL1Cy, previousYear: newL1Py };
                            //   });

                            //   if (droppedItems && droppedItems.length > 0) {
                            //     const targetSubGrp = (isBsTable && l2.subgroup && l2.subgroup.length > 0)
                            //       ? l2.subgroup[0].name
                            //       : "";

                            //     const updatedData = droppedItems.map(item => {
                            //       const dragItem = item?.item_ || item;
                            //       let finalMapData = {};

                            //       if (checkYearly) {
                            //         if (draggedColumn === "cy") {
                            //           finalMapData = {
                            //             cy_map: { fs_grp: l1.name, note_grp: l2.name, note_no: l2.notes, sub_grp: targetSubGrp },
                            //             py_map: dragItem.map_data?.py_map || {
                            //               fs_grp: dragItem.fs_grp || "",
                            //               note_grp: dragItem.note_grp || "",
                            //               note_no: dragItem.note_no || "",
                            //               sub_grp: dragItem.sub_grp || ""
                            //             }
                            //           };
                            //         } else { // py
                            //           finalMapData = {
                            //             cy_map: dragItem.map_data?.cy_map || {
                            //               fs_grp: dragItem.fs_grp || "",
                            //               note_grp: dragItem.note_grp || "",
                            //               note_no: dragItem.note_no || "",
                            //               sub_grp: dragItem.sub_grp || ""
                            //             },
                            //             py_map: { fs_grp: l1.name, note_grp: l2.name, note_no: l2.notes, sub_grp: targetSubGrp }
                            //           };
                            //         }
                            //       } else {
                            //         finalMapData = {
                            //           cy_map: { fs_grp: l1.name, note_grp: l2.name, note_no: l2.notes, sub_grp: targetSubGrp },
                            //           py_map: { fs_grp: l1.name, note_grp: l2.name, note_no: l2.notes, sub_grp: targetSubGrp },
                            //         };
                            //       }

                            //       const currentYearMap = finalMapData.cy_map || {
                            //         fs_grp: dragItem.fs_grp || "",
                            //         note_grp: dragItem.note_grp || "",
                            //         note_no: dragItem.note_no || "",
                            //         sub_grp: dragItem.sub_grp || ""
                            //       };

                            //       return {
                            //         ...dragItem,
                            //         fs_grp: currentYearMap.fs_grp,
                            //         note_grp: currentYearMap.note_grp,
                            //         note_no: currentYearMap.note_no,
                            //         sub_grp: currentYearMap.sub_grp,
                            //         map_data: finalMapData
                            //       };
                            //     });

                            //     setIsUpdating(true);
                            //     try {
                            //       await dispatch(batchUpdateConventionalMode(conventionModeData.set_payload, updatedData));
                            //       if (!isMounted.current) return;
                            //       if (typeof onAfterDrop === 'function') onAfterDrop(droppedItems?.length || 1);
                            //     } finally {
                            //       if (isMounted.current) setIsUpdating(false);
                            //     }
                            //   }

                            //   if (!isMounted.current) return;
                            //   setData(updatedGrouping);
                            //   setUpdateTabs?.(prev => !prev);
                            //   return;
                            // }
                          }}
                          style={{
                            ...rowDraggingStyle,
                          }}
                        >
                          <td
                            className="text-left"
                            style={{
                              borderTop: isDragging ? "1px solid #3AB67D" : "0.5px solid transparent",
                              borderBottom: isDragging ? "1px solid #3AB67D" : "0.5px solid transparent",
                              borderLeft: isDragging ? "1px solid #3AB67D" : undefined,
                              backgroundColor: isDragging ? "#fff" : undefined,
                              padding: "8px 8px 8px 15px",
                              fontWeight: isL2Bold ? "700" : "normal",
                            }}
                          >
                          {l2.isNewRow ? (
                          <input
                            type="text"
                            placeholder="Enter line item"
                            value={l2.name}
                            onChange={(e) => {
                              const updated = data.map((item) => {
                                if (item._id !== l1._id) return item;

                                return {
                                  ...item,
                                  subgroup: item.subgroup.map((sub) =>
                                    sub._id === l2._id
                                      ? {
                                          ...sub,
                                          name: e.target.value,
                                        }
                                      : sub
                                  ),
                                };
                              });

                              setData(updated);
                            }}
                            style={{
                              border: "none",
                              outline: "none",
                              background: "transparent",
                              width: "100%",
                              color: "#111",
                              fontWeight: isL2Bold ? "700" : "normal",
                            }}
                          />
                        ) : (
                          l2.name
                        )}
                          </td>
                          <td
                            ref={highlightedNoteId === l2._id ? highlightedRowRef : null}
                            style={{
                              borderTop: isDragging ? "1px solid #3AB67D" : "0.5px solid transparent",
                              borderBottom: isDragging ? "1px solid #3AB67D" : "0.5px solid transparent",
                              backgroundColor: isDragging ? "#fff" : undefined,
                              padding: "8px",
                              cursor: "pointer",
                              textDecoration: "underline",
                              textAlign: "center",
                              transition: "background-color 0.3s ease",
                              fontWeight: isL2Bold ? "700" : "normal",
                            }}
                            onClick={() => handleNoteClick(l1, l2)}
                          >
                            {l2.notes ?? ""}
                          </td>
                          <td
                            className="text-right"
                            style={{
                              borderTop: isDragging ? "1px solid #3AB67D" : "0.5px solid transparent",
                              borderBottom: isDragging ? "1px solid #3AB67D" : "0.5px solid transparent",
                              backgroundColor: isDragging ? "#fff" : undefined,
                              padding: "8px",
                              fontWeight: isL2Bold ? "700" : "normal",
                            }}
                          >
                           {l2.isNewRow ? (
                            <input
                                type="text"
                                placeholder="0"
                                value={l2.currentYear}
                                onChange={(e) => {
                                  const updated = data.map((item) => {
                                    if (item._id !== l1._id) return item;

                                    return {
                                      ...item,
                                      subgroup: item.subgroup.map((sub) =>
                                        sub._id === l2._id
                                          ? {
                                              ...sub,
                                              currentYear: e.target.value,
                                            }
                                          : sub
                                      ),
                                    };
                                  });

                                  setData(updated);
                                }}
                                style={{
                                  border: "none",
                                  outline: "none",
                                  background: "transparent",
                                  width: "100%",
                                  textAlign: "right",
                                  fontWeight: isL2Bold ? "700" : "normal",
                                }}
                              />
                            ) : (
                              formatIndianCurrency(Math.round(Number(l2.currentYear ?? 0)))
                            )}
                          </td>
                          <td
                            className="text-right"
                            style={{
                              borderTop: isDragging ? "1px solid #3AB67D" : "0.5px solid transparent",
                              borderBottom: isDragging ? "1px solid #3AB67D" : "0.5px solid transparent",
                              backgroundColor: isDragging ? "#fff" : undefined,
                              padding: "8px",
                              position: "relative",
                              fontWeight: isL2Bold ? "700" : "normal",
                            }}
                          >
                           {l2.isNewRow ? (
                            <input
                              type="text"
                              placeholder="0"
                              value={l2.previousYear}
                              onChange={(e) => {
                                const updated = data.map((item) => {
                                  if (item._id !== l1._id) return item;

                                  return {
                                    ...item,
                                    subgroup: item.subgroup.map((sub) =>
                                      sub._id === l2._id
                                        ? {
                                            ...sub,
                                            previousYear: e.target.value,
                                          }
                                        : sub
                                    ),
                                  };
                                });

                                setData(updated);
                              }}
                              style={{
                                border: "none",
                                outline: "none",
                                background: "transparent",
                                width: "100%",
                                textAlign: "right",
                                fontWeight: isL2Bold ? "700" : "normal",
                              }}
                            />
                            ) : (
                              formatIndianCurrency(Math.round(Number(l2.previousYear ?? 0)))
                            )}
                          </td>
                        <td
                          className="text-center"
                          style={{
                            borderTop: isDragging ? "1px solid #3AB67D" : "0.5px solid transparent",
                            borderBottom: isDragging ? "1px solid #3AB67D" : "0.5px solid transparent",
                            borderRight: isDragging ? "1px solid #3AB67D" : undefined,
                            backgroundColor: isDragging ? "#fff" : undefined,
                            padding: "8px 2px",
                            width: "60px",
                          }}
                        >
                          {hoveredL2Id === l2._id && !l2.isNewRow && (
                           <span style={{ display: 'inline-flex', gap: '6px', verticalAlign: 'middle' }}>
                             <button style={{border: 'none', background: 'transparent', cursor: 'pointer', padding: 2, color: '#4CAF50', display: 'inline-flex', alignItems: 'center'}} onClick={(e) => { e.stopPropagation(); setEditingItem({ level: 2, levelOneID: l1._id, levelTwoID: l2._id, name: l2.name }); }}><EditIcon width={16} height={16} /></button>
                             <button style={{border: 'none', background: 'transparent', cursor: 'pointer', padding: 2, color: '#F44336', display: 'inline-flex', alignItems: 'center'}} onClick={(e) => { e.stopPropagation(); handleDeleteGroupingItem(2, l1._id, l2._id); }}><DeleteIcon width={16} height={16} /></button>
                           </span>
                         )}
                        </td>
                      </tr>
                    );
                  })}
                    {l1.lineType !== "formula" && (
                      <tr>
                        <td colSpan={5} style={{ padding: "14px 8px 14px 14px" }}>
                          <button
                            onClick={() => {
                              setActiveL1(l1);
                              setItemName("");
                              setSelectedItem("line item");
                              setLineItemNature("credit");
                              setFormulaItems([{ element: Date.now(), value: "", operator: "positive" }]);
                              setPendingOperator("positive");
                              setShowAddL2Modal(true);
                            }}
                            style={{
                              border: "none",
                              background: "transparent",
                              color: "#2D8861",
                              cursor: "pointer",
                              fontWeight: 500,
                              fontSize: "14px",
                            }}
                          >
                            <AddIcon width={16} height={16} style={{ marginTop: "-3px", marginRight: "4px"}}/>
                             Add Level 2 Note Group
                          </button>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {isUpdating && (
          <div style={{
            position: "absolute",
            inset: 0,
            display: "grid",
            placeItems: "center",
            backgroundColor: "transparent",
            zIndex: 20,
          }}>
            <style>{`@keyframes spin {0% {transform: rotate(0deg);} 100% {transform: rotate(360deg);} }`}</style>
            <div style={{
              display: "grid",
              placeItems: "center",
              background: "transparent",
              boxShadow: "none",
            }}>
              <div style={{
                width: 60,
                height: 60,
                borderRadius: "50%",
                border: "6px solid rgba(0, 0, 0, 0.1)",
                borderTopColor: "#47b36b",
                animation: "spin 0.9s linear infinite",
              }} />
            </div>
          </div>
        )}

            {editingItem && (
          <div style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            zIndex: 9999,
          }}
          onClick={() => setEditingItem(null)}
          >
            <div
              className={sidePanelStyles.sidePanel}
              style={{
                width: editSelectedItem === "formula" && editFormulaItems.length > 1 ? "966px" : "650px",
                minWidth: editSelectedItem === "formula" && editFormulaItems.length > 1 ? "966px" : "650px",
                maxWidth: editSelectedItem === "formula" && editFormulaItems.length > 1 ? "95vw" : "650px",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div className={sidePanelStyles.panelHeader}>
                <span>Edit Level {editingItem.level} {editingItem.level === 3 ? 'SubNote Group' : 'Note Group'}</span>
                <span 
                  className={sidePanelStyles.close} 
                  onClick={() => setEditingItem(null)}
                >
                  ✕
                </span>
              </div>

              <div className={sidePanelStyles.panelBody} style={{ padding: "20px" }}>
                <div className={libcss.customRadioSection} style={{ marginBottom: "20px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "nowrap", gap: "16px" }}>
                  <RadioGroup
                    row
                    name="editType"
                    value={editSelectedItem}
                    onChange={(e) => setEditSelectedItem(e.target.value)}
                    style={{ margin: 0 }}
                  >
                    <FormControlLabel
                      value="line item"
                      className={libcss.customRadioLabel}
                      control={
                        <Radio
                          sx={{
                            "& .MuiSvgIcon-root": { fontSize: 18 },
                            color: "#D6D6D6",
                            "&.Mui-checked": { color: "#3AB67D" },
                          }}
                        />
                      }
                      label="Line Item"
                    />
                    <FormControlLabel
                      className={libcss.customRadioLabel}
                      value="formula"
                      control={
                        <Radio
                          sx={{
                            "& .MuiSvgIcon-root": { fontSize: 18 },
                            color: "#D6D6D6",
                            "&.Mui-checked": { color: "#3AB67D" },
                          }}
                        />
                      }
                      label="Formula"
                    />
                  </RadioGroup>

                  {(editSelectedItem === "formula" || editSelectedItem === "line item") && (
                    <div style={{ display: "flex", alignItems: "center", gap: "16px", flexShrink: 0 }}>
                      <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "#33584E" }}>
                        <input
                          type="checkbox"
                          checked={editIsBold || editIsTotal || editIsSubtotal}
                          onChange={(e) => {
                            if (!editIsTotal && !editIsSubtotal) {
                              setEditIsBold(e.target.checked);
                            }
                          }}
                          style={{ accentColor: "#3AB67D", margin: 0, width: "16px", height: "16px" }}
                        />
                        Bold
                      </label>
                      <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "#33584E" }}>
                        <input
                          type="checkbox"
                          checked={editIsTotal}
                          onChange={(e) => handleEditTotalToggle(e.target.checked)}
                          style={{ accentColor: "#3AB67D", margin: 0, width: "16px", height: "16px" }}
                        />
                        Total
                      </label>
                      <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "#33584E" }}>
                        <input
                          type="checkbox"
                          checked={editIsSubtotal}
                          onChange={(e) => handleEditSubtotalToggle(e.target.checked)}
                          style={{ accentColor: "#3AB67D", margin: 0, width: "16px", height: "16px" }}
                        />
                        Subtotal
                      </label>
                    </div>
                  )}
                </div>

                {editSelectedItem === "line item" && (
                  <>
                    <InputGroup
                      class_="mb-2"
                      width="100%"
                      label="Line Item Name"
                      inputs={[
                        <input
                          key="edit-line-item-input"
                          name="line item name"
                          value={editItemName}
                          onChange={(e) => setEditItemName(e.target.value)}
                          placeholder="Type something..."
                          style={{
                            width: "100%",
                            height: "37px",
                            padding: "10px 12px",
                            border: "1px solid #c2e6d1",
                            backgroundColor: "#f4faf5",
                            color: "#205a46",
                            borderRadius: "8px",
                            fontSize: "14px",
                            outline: "none",
                            boxSizing: "border-box",
                          }}
                        />
                      ]}
                    />
                    
                    {editingItem?.level === 1 && (
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
                        <span className={`${commoncss.label3} ${commoncss.fs14}`} style={{ color: "#205a46", fontWeight: 500, paddingLeft: "10px" }}>
                          Nature Of Line Item
                        </span>
                        <div className={libcss.customRadioSection}>
                          <RadioGroup
                            row
                            name="editNature"
                            value={editLineItemNature}
                            onChange={(e) => setEditLineItemNature(e.target.value)}
                          >
                            <FormControlLabel
                              value="credit"
                              className={libcss.customRadioLabel}
                              control={
                                <Radio
                                  sx={{
                                    "& .MuiSvgIcon-root": { fontSize: 18 },
                                    color: "#D6D6D6",
                                    "&.Mui-checked": { color: "#3AB67D" },
                                  }}
                                />
                              }
                              label="Credit"
                            />
                            <FormControlLabel
                              value="debit"
                              className={libcss.customRadioLabel}
                              control={
                                <Radio
                                  sx={{
                                    "& .MuiSvgIcon-root": { fontSize: 18 },
                                    color: "#D6D6D6",
                                    "&.Mui-checked": { color: "#3AB67D" },
                                  }}
                                />
                              }
                              label="Debit"
                            />
                          </RadioGroup>
                        </div>
                      </div>
                    )}
                  </>
                )}

                {editSelectedItem === "formula" && (
                  <div>
                    <div style={{ width: "100%" }}>
                      <InputGroup
                        class_="mb-2"
                        width="100%"
                        label="Formula Name"
                        inputs={[
                          <input
                            key="edit-formula-input"
                            name="Formula name"
                            value={editItemName}
                            onChange={(e) => setEditItemName(e.target.value)}
                            placeholder="Enter formula name"
                            style={{
                              width: "100%",
                              height: "37px",
                              padding: "10px 12px",
                              border: "1px solid #c2e6d1",
                              backgroundColor: "#f4faf5",
                              color: "#205a46",
                              borderRadius: "8px",
                              fontSize: "14px",
                              outline: "none",
                              boxSizing: "border-box",
                            }}
                          />
                        ]}
                      />

                      <div className={`${libcss.displayFormula} mt-3`} style={{ whiteSpace: "normal", wordBreak: "break-word" , margin: "30px 0"}}>
                        <span className={`${commoncss.label5} ${commoncss.fw500}`} style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px" }}>
                          <span>Formula =</span>
                          {renderFormulaDisplay(editFormulaItems)}
                        </span>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "20px 12px",
                        flexWrap: "wrap",
                        marginTop: "16px"
                      }}
                    >
                      {editFormulaItems.map((fitem, index) => (
                        <React.Fragment key={fitem.element ?? index}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "12px"
                            }}
                          >
                            <div className={libcss.formulaCard} style={{ margin: 0, width: "245px", height: "110px", minHeight: "75px", padding: "10px", background: "#f4faf5", border: "1px solid #c2e6d1", borderRadius: "10px" }}>
                              <span
                                className={`${commoncss.label3} ${commoncss.fw600}`}
                                style={{ color: "#205a46", fontSize: "13px", display: "block", marginBottom: "8px" }}
                              >
                                LEVEL {editingItem.level}
                              </span>

                              <div style={{ width: "100%" }}>
                                <Dropdown
                                  wrapText={true}
                                  searchable={true}
                                  class2_={commoncss.bgWhite}
                                  options={getEditingDropdownOptions()}
                                  name="editFormula"
                                  selected={fitem.value}
                                  onSelect={(val) => updateEditFormulaItem(index, val)}
                                  placeHolder="Select item"
                                />
                              </div>
                            </div>

                            {index < editFormulaItems.length - 1 && (
                              <div style={{ marginTop: "0px" }}>
                                <OperatorBtn
                                  value={editFormulaItems[index + 1].operator}
                                  onChange={(v) => updateEditFormulaOperator(index + 1, v)}
                                />
                              </div>
                            )}
                            {index === editFormulaItems.length - 1 && (
                              <div style={{ marginTop: "0px" }}>
                                <OperatorBtn
                                  value={editPendingOperator}
                                  onChange={(v) => setEditPendingOperator(v)}
                                />
                              </div>
                            )}
                          </div>
                        </React.Fragment>
                      ))}

                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <div
                          className={sidePanelStyles.addElementBox1}
                          onClick={addEditFormulaItem}
                          style={{
                           // width: "245px",
                            height: "110px",
                            marginTop: "0px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "10px",
                            cursor: "pointer"
                          }}
                        >
                          <p style={{ margin: 0, fontSize: "14px", fontWeight: 500, color: "#B3C0BD" }}>
                            <AddElement style={{  width:"15px", height:"15px", verticalAlign: "middle", marginTop: "-3px", marginRight: "4px" }} />
                            Add Element
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className={sidePanelStyles.footer}>
                <button 
                  className={sidePanelStyles.cancelBtn} 
                  onClick={() => setEditingItem(null)}
                >
                  Cancel
                </button>
                <button 
                  className={sidePanelStyles.applyBtn} 
                  onClick={handleUpdateGroupingItem}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        )}
        <style>{`
          .${sidePanelStyles.sidePanel} .${sidePanelStyles.panelHeader} {
            font-size: 18px !important;
          }
          .${sidePanelStyles.sidePanel} .${sidePanelStyles.panelBody} label,
          .${sidePanelStyles.sidePanel} .${sidePanelStyles.panelBody} .input-col input,
          .${sidePanelStyles.sidePanel} .${sidePanelStyles.panelBody} .input-label,
          .${sidePanelStyles.sidePanel} .${sidePanelStyles.panelBody} span:not(.${libcss.formulaCard} span) {
            font-size: 15px !important;
          }
          .${sidePanelStyles.sidePanel} .${libcss.formulaCard} input {
            font-size: 12px !important;
          }
        `}</style>

        {showAddL1Modal && (
          <div style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            zIndex: 9999,
          }}
          onClick={() => setShowAddL1Modal(false)}
          >
            <div
              className={sidePanelStyles.sidePanel}
              style={{
                width: selectedItem === "formula" && formulaItems.length > 1 ? "966px" : "650px",
                minWidth: selectedItem === "formula" && formulaItems.length > 1 ? "966px" : "650px",
                maxWidth: selectedItem === "formula" && formulaItems.length > 1 ? "95vw" : "650px",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div className={sidePanelStyles.panelHeader}>
                <span>Add Level 1 Note Group</span>
                <span 
                  className={sidePanelStyles.close} 
                  onClick={() => setShowAddL1Modal(false)}
                >
                  ✕
                </span>
              </div>

              <div className={sidePanelStyles.panelBody} style={{ padding: "20px" }}>
                <div className={libcss.customRadioSection} style={{ marginBottom: "20px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "nowrap", gap: "16px" }}>
                  <RadioGroup
                    row
                    name="l1Type"
                    value={selectedItem}
                    onChange={(e) => setSelectedItem(e.target.value)}
                    style={{ margin: 0 }}
                  >
                    <FormControlLabel
                      value="line item"
                      className={libcss.customRadioLabel}
                      control={
                        <Radio
                          sx={{
                            "& .MuiSvgIcon-root": { fontSize: 18 },
                            color: "#D6D6D6",
                            "&.Mui-checked": { color: "#3AB67D" },
                          }}
                        />
                      }
                      label="Line Item"
                    />
                    <FormControlLabel
                      className={libcss.customRadioLabel}
                      value="formula"
                      control={
                        <Radio
                          sx={{
                            "& .MuiSvgIcon-root": { fontSize: 18 },
                            color: "#D6D6D6",
                            "&.Mui-checked": { color: "#3AB67D" },
                          }}
                        />
                      }
                      label="Formula"
                    />
                  </RadioGroup>

                  {(selectedItem === "formula" || selectedItem === "line item") && (
                    <div style={{ display: "flex", alignItems: "center", gap: "16px", flexShrink: 0 }}>
                      <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "#33584E" }}>
                        <input
                          type="checkbox"
                          checked={isBold || isTotal || isSubtotal}
                          onChange={(e) => {
                            if (!isTotal && !isSubtotal) {
                              setIsBold(e.target.checked);
                            }
                          }}
                          style={{ accentColor: "#3AB67D", margin: 0, width: "16px", height: "16px" }}
                        />
                        Bold
                      </label>
                      <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "#33584E" }}>
                        <input
                          type="checkbox"
                          checked={isTotal}
                          onChange={(e) => handleTotalToggle(e.target.checked)}
                          style={{ accentColor: "#3AB67D", margin: 0, width: "16px", height: "16px" }}
                        />
                        Total
                      </label>
                      <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "#33584E" }}>
                        <input
                          type="checkbox"
                          checked={isSubtotal}
                          onChange={(e) => handleSubtotalToggle(e.target.checked)}
                          style={{ accentColor: "#3AB67D", margin: 0, width: "16px", height: "16px" }}
                        />
                        Subtotal
                      </label>
                    </div>
                  )}
                </div>

                {selectedItem === "line item" && (
                  <>
                    <InputGroup
                      class_="mb-2"
                      width="100%"
                      label="Line Item Name"
                      inputs={[
                        <input
                          key="line-item-input-l1"
                          name="line item name"
                          value={itemName}
                          onChange={(e) => setItemName(e.target.value)}
                          placeholder="Type something..."
                          style={{
                            width: "100%",
                            height: "37px",
                            padding: "10px 12px",
                            border: "1px solid #c2e6d1",
                            backgroundColor: "#f4faf5",
                            color: "#205a46",
                            borderRadius: "8px",
                            fontSize: "14px",
                            outline: "none",
                            boxSizing: "border-box",
                          }}
                        />
                      ]}
                    />
                    
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
                      <span className={`${commoncss.label3} ${commoncss.fs14}`} style={{ color: "#205a46", fontWeight: 500, paddingLeft: "10px" }}>
                        Nature Of Line Item
                      </span>
                      <div className={libcss.customRadioSection}>
                        <RadioGroup
                          row
                          name="l1Nature"
                          value={lineItemNature}
                          onChange={(e) => setLineItemNature(e.target.value)}
                        >
                          <FormControlLabel
                            value="credit"
                            className={libcss.customRadioLabel}
                            control={
                              <Radio
                                sx={{
                                  "& .MuiSvgIcon-root": { fontSize: 18 },
                                  color: "#D6D6D6",
                                  "&.Mui-checked": { color: "#3AB67D" },
                                }}
                              />
                            }
                            label="Credit"
                          />
                          <FormControlLabel
                            value="debit"
                            className={libcss.customRadioLabel}
                            control={
                              <Radio
                                sx={{
                                  "& .MuiSvgIcon-root": { fontSize: 18 },
                                  color: "#D6D6D6",
                                  "&.Mui-checked": { color: "#3AB67D" },
                                }}
                              />
                            }
                            label="Debit"
                          />
                        </RadioGroup>
                      </div>
                    </div>
                  </>
                )}

                {selectedItem === "formula" && (
                  <div>
                    <div style={{ width: "100%" }}>
                      <InputGroup
                        class_="mb-2"
                        width="100%"
                        label="Formula Name"
                        inputs={[
                          <input
                            key="formula-input-l1"
                            name="Formula name"
                            value={itemName}
                            onChange={(e) => setItemName(e.target.value)}
                            placeholder="Enter formula name"
                            style={{
                              width: "100%",
                              height: "37px",
                              padding: "10px 12px",
                              border: "1px solid #c2e6d1",
                              backgroundColor: "#f4faf5",
                              color: "#205a46",
                              borderRadius: "8px",
                              fontSize: "14px",
                              outline: "none",
                              boxSizing: "border-box",
                            }}
                          />
                        ]}
                      />

                      <div className={`${libcss.displayFormula} mt-3`} style={{ whiteSpace: "normal", wordBreak: "break-word" , margin: "30px 0"}}>
                        <span className={`${commoncss.label5} ${commoncss.fw500}`} style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px" }}>
                          <span>Formula =</span>
                          {renderFormulaDisplay(formulaItems)}
                        </span>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "20px 12px",
                        flexWrap: "wrap",
                        marginTop: "16px"
                      }}
                    >
                      {formulaItems.map((fitem, index) => (
                        <React.Fragment key={fitem.element ?? index}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "12px"
                            }}
                          >
                            <div className={libcss.formulaCard} style={{ margin: 0, width: "245px", height: "110px", minHeight: "75px", padding: "10px", background: "#f4faf5", border: "1px solid #c2e6d1", borderRadius: "10px" }}>
                              <span
                                className={`${commoncss.label3} ${commoncss.fw600}`}
                                style={{ color: "#205a46", fontSize: "13px", display: "block", marginBottom: "8px" }}
                              >
                                LEVEL 1
                              </span>

                              <div style={{ width: "100%" }}>
                                <Dropdown
   wrapText={true}
   searchable={true}
                                  class2_={commoncss.bgWhite}
                                  options={(data || [])
                                    .filter((sub) => sub && sub.name && !sub.isNewRow)
                                    .map((sub) => ({ label: sub.name, value: sub.name }))}
                                  name="formula"
                                  selected={fitem.value}
                                  onSelect={(val) => updateFormulaItem(index, val)}
                                  placeHolder="Select item"
                                />
                              </div>
                            </div>

                            {index < formulaItems.length - 1 && (
                              <div style={{ marginTop: "0px" }}>
                                <OperatorBtn
                                  value={formulaItems[index + 1].operator}
                                  onChange={(v) => updateFormulaOperator(index + 1, v)}
                                />
                              </div>
                            )}
                            {index === formulaItems.length - 1 && (
                              <div style={{ marginTop: "0px" }}>
                                <OperatorBtn
                                  value={pendingOperator}
                                  onChange={(v) => setPendingOperator(v)}
                                />
                              </div>
                            )}
                          </div>
                        </React.Fragment>
                      ))}

                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <div
                          className={sidePanelStyles.addElementBox1}
                          onClick={addFormulaItem}
                          style={{
                           // maxWidth: "285px",
                            height: "110px",
                            marginTop: "0px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "10px",
                            cursor: "pointer"
                          }}
                        >
                          <p style={{ margin: 0, fontSize: "14px", fontWeight: 500, color: "#B3C0BD" }}>
                            <AddElement style={{ width:"15px", height:"15px", verticalAlign: "middle", marginTop: "-3px", marginRight: "4px" }} />
                            Add Element
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className={sidePanelStyles.footer}>
                <button 
                  className={sidePanelStyles.cancelBtn} 
                  onClick={() => setShowAddL1Modal(false)}
                >
                  Cancel
                </button>
                <button 
                  className={sidePanelStyles.applyBtn} 
                  onClick={handleCreateL1}
                >
                  Create
                </button>
              </div>
            </div>
          </div>
        )}

        {showAddL2Modal && (
          <div style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            zIndex: 9999,
          }}
          onClick={() => setShowAddL2Modal(false)}
          >
            <div
              className={sidePanelStyles.sidePanel}
              style={{
                width: selectedItem === "formula" && formulaItems.length > 1 ? "966px" : "650px",
                minWidth: selectedItem === "formula" && formulaItems.length > 1 ? "966px" : "650px",
                maxWidth: selectedItem === "formula" && formulaItems.length > 1 ? "95vw" : "650px",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div className={sidePanelStyles.panelHeader}>
                <span>Add Level 2 Note Group</span>
                <span 
                  className={sidePanelStyles.close} 
                  onClick={() => setShowAddL2Modal(false)}
                >
                  ✕
                </span>
              </div>

              <div className={sidePanelStyles.panelBody} style={{ padding: "20px" }}>
                <div className={libcss.customRadioSection} style={{ marginBottom: "20px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "nowrap", gap: "16px" }}>
                  <RadioGroup
                    row
                    name="l2Type"
                    value={selectedItem}
                    onChange={(e) => setSelectedItem(e.target.value)}
                    style={{ margin: 0 }}
                  >
                    <FormControlLabel
                      value="line item"
                      className={libcss.customRadioLabel}
                      control={
                        <Radio
                          sx={{
                            "& .MuiSvgIcon-root": { fontSize: 18 },
                            color: "#D6D6D6",
                            "&.Mui-checked": { color: "#3AB67D" },
                          }}
                        />
                      }
                      label="Line Item"
                    />
                    <FormControlLabel
                      className={libcss.customRadioLabel}
                      value="formula"
                      control={
                        <Radio
                          sx={{
                            "& .MuiSvgIcon-root": { fontSize: 18 },
                            color: "#D6D6D6",
                            "&.Mui-checked": { color: "#3AB67D" },
                          }}
                        />
                      }
                      label="Formula"
                    />
                  </RadioGroup>

                  {(selectedItem === "formula" || selectedItem === "line item") && (
                    <div style={{ display: "flex", alignItems: "center", gap: "16px", flexShrink: 0 }}>
                      <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "#33584E" }}>
                        <input
                          type="checkbox"
                          checked={isBold || isTotal || isSubtotal}
                          onChange={(e) => {
                            if (!isTotal && !isSubtotal) {
                              setIsBold(e.target.checked);
                            }
                          }}
                          style={{ accentColor: "#3AB67D", margin: 0, width: "16px", height: "16px" }}
                        />
                        Bold
                      </label>
                      <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "#33584E" }}>
                        <input
                          type="checkbox"
                          checked={isTotal}
                          onChange={(e) => handleTotalToggle(e.target.checked)}
                          style={{ accentColor: "#3AB67D", margin: 0, width: "16px", height: "16px" }}
                        />
                        Total
                      </label>
                      <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "#33584E" }}>
                        <input
                          type="checkbox"
                          checked={isSubtotal}
                          onChange={(e) => handleSubtotalToggle(e.target.checked)}
                          style={{ accentColor: "#3AB67D", margin: 0, width: "16px", height: "16px" }}
                        />
                        Subtotal
                      </label>
                    </div>
                  )}
                </div>

                {selectedItem === "line item" && (
                  <>
                    <InputGroup
                      class_="mb-2"
                      width="100%"
                      label="Line Item Name"
                      inputs={[
                        <input
                          key="line-item-input-l2"
                          name="line item name"
                          value={itemName}
                          onChange={(e) => setItemName(e.target.value)}
                          placeholder="Type something..."
                          style={{
                            width: "100%",
                            height: "37px",
                            padding: "10px 12px",
                            border: "1px solid #c2e6d1",
                            backgroundColor: "#f4faf5",
                            color: "#205a46",
                            borderRadius: "8px",
                            fontSize: "14px",
                            outline: "none",
                            boxSizing: "border-box",
                          }}
                        />
                      ]}
                    />
                    

                  </>
                )}

                {selectedItem === "formula" && (
                  <div>
                    <div style={{ width: "100%" }}>
                      <InputGroup
                        class_="mb-2"
                        width="100%"
                        label="Formula Name"
                        inputs={[
                          <input
                            key="formula-input-l2"
                            name="Formula name"
                            value={itemName}
                            onChange={(e) => setItemName(e.target.value)}
                            placeholder="Enter formula name"
                            style={{
                              width: "100%",
                              padding: "10px 12px",
                              height: "37px",
                              border: "1px solid #c2e6d1",
                              backgroundColor: "#f4faf5",
                              color: "#205a46",
                              borderRadius: "8px",
                              fontSize: "14px",
                              outline: "none",
                              boxSizing: "border-box",
                            }}
                          />
                        ]}
                      />

                      <div className={`${libcss.displayFormula} mt-3`} style={{ whiteSpace: "normal", wordBreak: "break-word" , margin: "30px 0"}}>
                        <span className={`${commoncss.label5} ${commoncss.fw500}`} style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px" }}>
                          <span>Formula =</span>
                          {renderFormulaDisplay(formulaItems)}
                        </span>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "20px 12px",
                        flexWrap: "wrap",
                        marginTop: "16px"
                      }}
                    >
                      {formulaItems.map((fitem, index) => (
                        <React.Fragment key={fitem.element ?? index}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "12px"
                            }}
                          >
                            <div className={libcss.formulaCard} style={{ margin: 0, width: "245px", height: "110px", minHeight: "75px", padding: "10px", background: "#f4faf5", border: "1px solid #c2e6d1", borderRadius: "10px" }}>
                              <span
                                className={`${commoncss.label3} ${commoncss.fw600}`}
                                style={{ color: "#205a46", fontSize: "13px", display: "block", marginBottom: "8px" }}
                              >
                                LEVEL 2
                              </span>

                              <div style={{ width: "100%" }}>
                                <Dropdown
                                wrapText={true}
                                searchable={true}
                                  class2_={commoncss.bgWhite}
                                  options={(activeL1?.subgroup || [])
                                    .filter((sub) => sub && sub.name && !sub.isNewRow)
                                    .map((sub) => ({ label: sub.name, value: sub.name }))}
                                  name="formula"
                                  selected={fitem.value}
                                  onSelect={(val) => updateFormulaItem(index, val)}
                                  placeHolder="Select item"
                                />
                              </div>
                            </div>

                            {index < formulaItems.length - 1 && (
                              <div style={{ marginTop: "0px" }}>
                                <OperatorBtn
                                  value={formulaItems[index + 1].operator}
                                  onChange={(v) => updateFormulaOperator(index + 1, v)}
                                />
                              </div>
                            )}
                            {index === formulaItems.length - 1 && (
                              <div style={{ marginTop: "0px" }}>
                                <OperatorBtn
                                  value={pendingOperator}
                                  onChange={(v) => setPendingOperator(v)}
                                />
                              </div>
                            )}
                          </div>
                        </React.Fragment>
                      ))}

                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <div
                          className={sidePanelStyles.addElementBox1}
                          onClick={addFormulaItem}
                          style={{
                           // maxWidth: "285px",
                            height: "110px",
                            marginTop: "0px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                           // border: "1px solid #cfd8d5",
                            borderRadius: "10px",
                            cursor: "pointer"
                          }}
                        >
                          <p style={{ margin: 0, fontSize: "14px", fontWeight: 500, color: "#B3C0BD" }}>
                            <AddElement style={{ width:"15px", height:"15px", verticalAlign: "middle", marginTop: "-3px", marginRight: "4px" }} />
                            Add Element
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className={sidePanelStyles.footer}>
                <button 
                  className={sidePanelStyles.cancelBtn} 
                  onClick={() => setShowAddL2Modal(false)}
                >
                  Cancel
                </button>
                <button 
                  className={sidePanelStyles.applyBtn} 
                  onClick={handleCreateL2}
                >
                  Create
                </button>
              </div>
            </div>
          </div>
        )}

       {/* Render Delete Confirmation Popup */}
        <DeletePopup
          isOpen={deleteConfirmData !== null}
          title={<>Do you want to <span style={{ fontWeight: 700 }}>delete</span> selected items?</>}
          message="Once deleted, you can restore using the bin"
          onConfirm={async () => {
            if (!deleteConfirmData) return;
            const { level, l1Id, l2Id, l3Id } = deleteConfirmData;
            setDeleteConfirmData(null);
            await proceedDeleteGroupingItem(level, l1Id, l2Id, l3Id);
          }}
          onCancel={() => setDeleteConfirmData(null)}
        />

        {showSuccessPopup && (
          <SuccessPopup
            isOpen={showSuccessPopup}
            title="Success"
            message={successPopupMessage}
            onClose={() => setShowSuccessPopup(false)}
          />
        )}
        {errorData && (
          <ErrorPopup
            isOpen={errorData !== null}
            title={errorData.title}
            message={errorData.message}
            onClose={() => setErrorData(null)}
          />
        )}
      </div>
    );
  }

  // Render: Detail view (level2 + level3)
  return (
    <div style={{ position: "relative", flex: 1, height: "100%", border: "1px solid #ddd", borderRadius: "15px", backgroundColor: "#fff", overflow: "hidden", margin: "2px", width: "calc(100% - 4px)" }}>
      <div style={{ filter: isUpdating ? "blur(3px)" : "none", transition: "filter 0.2s ease", height: "100%" }}>
        <div
          ref={tableContainerRef}
          id="TemplateScroll"
          className="hide-scrollbar"
          style={{ height: "100%", overflow: "auto", paddingBottom: "20px" }}
          onScroll={(e) => {
            const newScroll = e.currentTarget.scrollTop;
            if (skipNextScrollEvent.current) {
              skipNextScrollEvent.current = false;
              return;
            }
            if (ignoreScrollResetsRef.current) {
              if (newScroll !== lastScrollPosRef.current) {
                console.log("[L3-DEBUG] Ignoring spurious scroll event during data update", newScroll);
                e.currentTarget.scrollTop = lastScrollPosRef.current;
              }
              return;
            }
            
            // Allow native scrolling (including drag autoscroll) and track the position
            lastScrollPosRef.current = newScroll;
            sessionStorage.setItem("l3DragScroll", newScroll);
          }}
        >
          <Button
            label={"Back"}
            onClick={handleBackToRoot}
            icon={<BackIcon width={13} height={13}  />}
            style={{
              background: "transparent",
              color: "#111111",
              border: "none",
              padding: 0,
              display: "flex",
              alignItems: "center",
              fontWeight: 500,
              marginBottom: 16,
              marginTop: "10px",
              boxShadow: "none",
              marginLeft: "-15px"
            }}
          />

          <table
            className={tablecss.customTable}
            style={{ minWidth: "100%", borderCollapse: "collapse", tableLayout: "auto" }}
          >
            <thead>
              <tr>
                <th className={`text-left`} style={{ position: "sticky", top: "0px", zIndex: 5, padding: "15px 8px 15px 15px", backgroundColor: "#ffffff", borderTop: "1px solid #ddd" }}>
                  LINE ITEM
                </th>
                <th className={`text-right`} style={{ position: "sticky", top: "0px", zIndex: 5, padding: "15px 8px", backgroundColor: "#ffffff",borderTop: "1px solid #ddd"  }}>
                  {currentYearLabel}
                </th>
                <th className={`text-right`} style={{ position: "sticky", top: "0px", zIndex: 5, padding: "15px 8px", backgroundColor: "#ffffff", borderTop: "1px solid #ddd"  }}>
                  {previousYearLabel}
                </th>
                <th className={`text-center`} style={{ position: "sticky", top: "0px", zIndex: 5, padding: "15px 2px", width: "60px", backgroundColor: "#ffffff",  borderTop: "1px solid #ddd"  }}>
                  
                </th>
              </tr>
            </thead>
            <tbody
              style={{
                background: `${theme ? "" : "#363535"}`,
                color: `${theme ? "" : "#fff"}`,
              }}
            >
              <tr className={`text-left pl-3 ${commoncss.highlightRow}`}>
                <td
                  colSpan={4}
                  className={`text-left pl-3 ${commoncss.highlightRow} ${commoncss.fs14} ${commoncss.fw600}`}
                  style={{
                    padding: "8px 8px 8px 14px",
                    borderBottom: "0.5px solid transparent",
                  }}
                >
                  {`${updatedL2?.name ?? level2?.name}`}
                </td>
              </tr>

              {(updatedL2?.subgroup || []).map((l3, index) => {
                const isHovered = hoveredL3Id === l3._id;
                const isL3Bold = !!(l3.isBold || l3.isTotal || l3.isSubtotal || l3.formulaType === "total" || l3.formulaType === "subtotal");
                const isDragging = draggingL3Id === l3._id;

                const rowDraggingStyle = isDragging ? {
                  backgroundColor: "#fff",
                  boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
                  zIndex: 9999,
                  position: "relative",
                } : isHovered ? {
                  backgroundColor: "#e6f7ff",
                } : {
                  backgroundColor: "transparent",
                };

                return (
                  <tr
                    key={l3._id}
                    onDragOver={onLevel3DragOver}
                    onDrop={onLevel3Drop(l3, index)}
                    onDragEnter={onLevel3DragEnter(l3._id)}
                    onDragLeave={onLevel3DragLeave(l3._id)}
                    onMouseEnter={() => setHoveredL3Id(l3._id)}
                    onMouseLeave={() => setHoveredL3Id(null)}
                    draggable
                    onMouseDown={() => {
                      const scroll = tableContainerRef.current?.scrollTop;
                      console.log("[L3-DEBUG] mousedown scrollTop:", scroll);
                      l3DragScrollRef.current = scroll ?? null;
                      isDraggingL3Ref.current = true; // lock immediately so onScroll can catch browser reset
                    }}
                    onMouseUp={() => {
                      // If no drag started (just a click), release lock
                      if (isDraggingL3Ref.current && !l3DragScrollRef.current) {
                        isDraggingL3Ref.current = false;
                      }
                    }}
                    onDragStart={(e) => {
                      setDraggingL3Id(l3._id);
                      const scroll = tableContainerRef.current?.scrollTop;
                      l3DragScrollRef.current = scroll ?? null;
                      isDraggingL3Ref.current = true;
                      e.dataTransfer.setData(
                        "text/plain",
                        JSON.stringify({
                          type: "reorderL3",
                          fromIndex: index,
                          l1Id: level1._id,
                          l2Id: updatedL2._id,
                        })
                      );
                    }}
                    onDragEnd={() => {
                      setDraggingL3Id(null);
                      console.log("[L3-DEBUG] dragend | l3DragScrollRef:", l3DragScrollRef.current);
                      isDraggingL3Ref.current = false;
                    }}
                    style={{
                      ...rowDraggingStyle,
                    }}
                  >
                    <td
                      className="text-left"
                      style={{
                        borderTop: isDragging ? "1.5px solid #3AB67D" : "0.5px solid transparent",
                        borderBottom: isDragging ? "1.5px solid #3AB67D" : "0.5px solid transparent",
                        borderLeft: isDragging ? "1.5px solid #3AB67D" : undefined,
                        boxShadow: isDragging ? "inset 0 1.5px 0 0 #3AB67D, inset 0 -1px 0 0 #3AB67D, inset 1.5px 0 0 0 #3AB67D" : undefined,
                        backgroundColor: isDragging ? "#fff" : undefined,
                        padding: "8px 8px 8px 15px",
                        fontWeight: isL3Bold ? "700" : "normal",
                      }}
                    >
                     {l3.isNewRow ? (
                        <input
                          type="text"
                          placeholder="Enter line item"
                          value={l3.name}
                          onChange={(e) => {
                            const updated = data.map((item) => {
                              if (item._id !== level1._id) return item;

                              return {
                                ...item,
                                subgroup: item.subgroup.map((sub) => {
                                  if (sub._id !== updatedL2._id) return sub;

                                  return {
                                    ...sub,
                                    subgroup: sub.subgroup.map((child) =>
                                      child._id === l3._id
                                        ? {
                                            ...child,
                                            name: e.target.value,
                                          }
                                        : child
                                    ),
                                  };
                                }),
                              };
                            });

                            setData(updated);
                          }}
                          style={{
                            border: "none",
                            outline: "none",
                            background: "transparent",
                            width: "100%",
                            fontWeight: isL3Bold ? "700" : "normal",
                          }}
                        />
                      ) : (
                        l3.name
                      )}
                    </td>
                    <td
                      className="text-right"
                      style={{
                        borderTop: isDragging ? "1.5px solid #3AB67D" : "0.5px solid transparent",
                        borderBottom: isDragging ? "1.5px solid #3AB67D" : "0.5px solid transparent",
                        boxShadow: isDragging ? "inset 0 1.5px 0 0 #3AB67D, inset 0 -1px 0 0 #3AB67D" : undefined,
                        backgroundColor: isDragging ? "#fff" : undefined,
                        padding: "8px",
                        fontWeight: isL3Bold ? "700" : "normal",
                      }}
                    >
                      {l3.isNewRow ? (
                      <input
                        type="text"
                        placeholder="0"
                        value={l3.currentYear}
                        onChange={(e) => {
                          const updated = data.map((item) => {
                            if (item._id !== level1._id) return item;

                            return {
                              ...item,
                              subgroup: item.subgroup.map((sub) => {
                                if (sub._id !== updatedL2._id) return sub;

                                return {
                                  ...sub,
                                  subgroup: sub.subgroup.map((child) =>
                                    child._id === l3._id
                                      ? {
                                          ...child,
                                          currentYear: e.target.value,
                                        }
                                      : child
                                  ),
                                };
                              }),
                            };
                          });

                          setData(updated);
                        }}
                        style={{
                          border: "none",
                          outline: "none",
                          background: "transparent",
                          width: "100%",
                          textAlign: "right",
                          fontWeight: isL3Bold ? "700" : "normal",
                        }}
                      />
                    ) : (     
                      formatIndianCurrency(Math.round(Number(l3.currentYear ?? 0)))
                    )}
                    </td>
                    <td
                      className="text-right"
                      style={{
                        borderTop: isDragging ? "1.5px solid #3AB67D" : "0.5px solid transparent",
                        borderBottom: isDragging ? "1.5px solid #3AB67D" : "0.5px solid transparent",
                        boxShadow: isDragging ? "inset 0 1.5px 0 0 #3AB67D, inset 0 -1px 0 0 #3AB67D" : undefined,
                        backgroundColor: isDragging ? "#fff" : undefined,
                        padding: "8px",
                        position: "relative",
                        fontWeight: isL3Bold ? "700" : "normal",
                      }}
                    >
                    {l3.isNewRow ? (
                      <input
                        type="text"
                        placeholder="0"
                        value={l3.previousYear}
                        onChange={(e) => {
                          const updated = data.map((item) => {
                            if (item._id !== level1._id) return item;

                            return {
                              ...item,
                              subgroup: item.subgroup.map((sub) => {
                                if (sub._id !== updatedL2._id) return sub;

                                return {
                                  ...sub,
                                  subgroup: sub.subgroup.map((child) =>
                                    child._id === l3._id
                                      ? {
                                          ...child,
                                          previousYear: e.target.value,
                                        }
                                      : child
                                  ),
                                };
                              }),
                            };
                          });

                          setData(updated);
                        }}
                        style={{
                          border: "none",
                          outline: "none",
                          background: "transparent",
                          width: "100%",
                          textAlign: "right",
                          fontWeight: isL3Bold ? "700" : "normal",
                        }}
                      />
                    ) : (
                      formatIndianCurrency(Math.round(Number(l3.previousYear ?? 0)))
                    )}
                    </td>
                    <td
                      className="text-center"
                      style={{
                        borderTop: isDragging ? "1.5px solid #3AB67D" : "0.5px solid transparent",
                        borderBottom: isDragging ? "1.5px solid #3AB67D" : "0.5px solid transparent",
                        borderRight: isDragging ? "1.5px solid #3AB67D" : undefined,
                        boxShadow: isDragging ? "inset 0 1.5px 0 0 #3AB67D, inset 0 -1px 0 0 #3AB67D, inset -1.5px 0 0 0 #3AB67D" : undefined,
                        backgroundColor: isDragging ? "#fff" : undefined,
                        padding: "8px 2px",
                        width: "60px",
                      }}
                    >
                   {hoveredL3Id === l3._id && !l3.isNewRow && (
                      <span
                        style={{
                          display: "inline-flex",
                          gap: "6px",
                          verticalAlign: "middle",
                        }}
                      >
                        <button
                          style={{
                            border: "none",
                            background: "transparent",
                            cursor: "pointer",
                            padding: 2,
                            color: "#4CAF50",
                            display: "inline-flex",
                            alignItems: "center",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();

                            setEditingItem({
                              level: 3,
                              levelOneID: level1._id,
                              levelTwoID: updatedL2._id,
                              levelThreeID: l3._id,
                              name: l3.name,
                            });
                          }}
                        >
                          <EditIcon width={16} height={16} />
                        </button>

                        <button
                          style={{
                            border: "none",
                            background: "transparent",
                            cursor: "pointer",
                            padding: 2,
                            color: "#F44336",
                            display: "inline-flex",
                            alignItems: "center",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();

                            handleDeleteGroupingItem(
                              3,
                              level1._id,
                              updatedL2._id,
                              l3._id
                            );
                          }}
                        >
                          <DeleteIcon width={16} height={16}/>
                        </button>
                      </span>
                    )}
                    </td>
                  </tr>
                );
              })}

              {!updatedL2?.subgroup?.length && (
                <tr>
                  <td
                    colSpan={4}
                    style={{
                      borderBottom: "0.5px solid transparent",
                      padding: "8px",
                    }}
                  >
                    No Level 3 items.
                  </td>
                </tr>
              )}
              <tr>
              <td colSpan={4} style={{ padding: "14px 8px 14px 15px" }}>
                <button
                  onClick={() => {
                    setActiveL2(updatedL2);
                    setItemName("");
                    setSelectedItem("line item");
                    setLineItemNature("credit");
                    setFormulaItems([{ element: Date.now(), value: "", operator: "positive" }]);
                    setPendingOperator("positive");
                    setShowAddL3Modal(true);
                  }}
                  style={{
                    border: "none",
                    background: "transparent",
                    color: "#2D8861",
                    cursor: "pointer",
                    fontWeight: 500,
                    fontSize: "15px",
                  }}
                >
                  <AddIcon width={16} height={16} style={{ marginTop: "-3px", marginRight: "4px"}}/> Add Level 3 SubNote Group
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      {isUpdating && (
        <div style={{
          position: "absolute",
          inset: 0,
          display: "grid",
          placeItems: "center",
          backgroundColor: "transparent",
          zIndex: 20,
        }}>
          <style>{`@keyframes spin {0% {transform: rotate(0deg);} 100% {transform: rotate(360deg);} }`}</style>
          <div style={{
            display: "grid",
            placeItems: "center",
            background: "transparent",
            boxShadow: "none",
          }}>
            <div style={{
              width: 60,
              height: 60,
              borderRadius: "50%",
              border: "6px solid rgba(0, 0, 0, 0.1)",
              borderTopColor: "#47b36b",
              animation: "spin 0.9s linear infinite",
            }} />
          </div>
        </div>
      )}

      {showAddL3Modal && (
        <div style={{
          position: "fixed",
          inset: 0,
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          zIndex: 9999,
        }}
        onClick={() => setShowAddL3Modal(false)}
        >
            <div
              className={sidePanelStyles.sidePanel}
              style={{
                width: selectedItem === "formula" && formulaItems.length > 1 ? "966px" : "650px",
                minWidth: selectedItem === "formula" && formulaItems.length > 1 ? "966px" : "650px",
                maxWidth: selectedItem === "formula" && formulaItems.length > 1 ? "95vw" : "650px",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div className={sidePanelStyles.panelHeader}>
                <span>Add Level 3 SubNote Group</span>
                <span 
                  className={sidePanelStyles.close} 
                  onClick={() => setShowAddL3Modal(false)}
                >
                  ✕
                </span>
              </div>

              <div className={sidePanelStyles.panelBody} style={{ padding: "20px" }}>
                <div className={libcss.customRadioSection} style={{ marginBottom: "20px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "nowrap", gap: "16px" }}>
                  <RadioGroup
                    row
                    name="l3Type"
                    value={selectedItem}
                    onChange={(e) => setSelectedItem(e.target.value)}
                    style={{ margin: 0 }}
                  >
                    <FormControlLabel
                      value="line item"
                      className={libcss.customRadioLabel}
                      control={
                        <Radio
                          sx={{
                            "& .MuiSvgIcon-root": { fontSize: 18 },
                            color: "#D6D6D6",
                            "&.Mui-checked": { color: "#3AB67D" },
                          }}
                        />
                      }
                      label="Line Item"
                    />
                    <FormControlLabel
                      className={libcss.customRadioLabel}
                      value="formula"
                      control={
                        <Radio
                          sx={{
                            "& .MuiSvgIcon-root": { fontSize: 18 },
                            color: "#D6D6D6",
                            "&.Mui-checked": { color: "#3AB67D" },
                          }}
                        />
                      }
                      label="Formula"
                    />
                  </RadioGroup>

                  {(selectedItem === "formula" || selectedItem === "line item") && (
                    <div style={{ display: "flex", alignItems: "center", gap: "16px", flexShrink: 0 }}>
                      <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "#33584E" }}>
                        <input
                          type="checkbox"
                          checked={isBold || isTotal || isSubtotal}
                          onChange={(e) => {
                            if (!isTotal && !isSubtotal) {
                              setIsBold(e.target.checked);
                            }
                          }}
                          style={{ accentColor: "#3AB67D", margin: 0, width: "16px", height: "16px" }}
                        />
                        Bold
                      </label>
                      <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "#33584E" }}>
                        <input
                          type="checkbox"
                          checked={isTotal}
                          onChange={(e) => handleTotalToggle(e.target.checked)}
                          style={{ accentColor: "#3AB67D", margin: 0, width: "16px", height: "16px" }}
                        />
                        Total
                      </label>
                      <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "#33584E" }}>
                        <input
                          type="checkbox"
                          checked={isSubtotal}
                          onChange={(e) => handleSubtotalToggle(e.target.checked)}
                          style={{ accentColor: "#3AB67D", margin: 0, width: "16px", height: "16px" }}
                        />
                        Subtotal
                      </label>
                    </div>
                  )}
                </div>

                {selectedItem === "line item" && (
                  <>
                    <InputGroup
                      class_="mb-2"
                      width="100%"
                      label="Line Item Name"
                      inputs={[
                        <input
                          key="line-item-input-l3"
                          name="line item name"
                          value={itemName}
                          onChange={(e) => setItemName(e.target.value)}
                          placeholder="Type something..."
                          style={{
                            width: "100%",
                            height: "37px",
                            padding: "10px 12px",
                            border: "1px solid #c2e6d1",
                            backgroundColor: "#f4faf5",
                            color: "#205a46",
                            borderRadius: "8px",
                            fontSize: "14px",
                            outline: "none",
                            boxSizing: "border-box",
                          }}
                        />
                      ]}
                    />
                    

                  </>
                )}

                {selectedItem === "formula" && (
                  <div>
                    <div style={{ width: "100%" }}>
                      <InputGroup
                        class_="mb-2"
                        width="100%"
                        label="Formula Name"
                        inputs={[
                          <input
                            key="formula-input-l3"
                            name="Formula name"
                            value={itemName}
                            onChange={(e) => setItemName(e.target.value)}
                            placeholder="Enter formula name"
                            style={{
                              width: "100%",
                              height: "37px",
                              padding: "10px 12px",
                              border: "1px solid #c2e6d1",
                              backgroundColor: "#f4faf5",
                              color: "#205a46",
                              borderRadius: "8px",
                              fontSize: "14px",
                              outline: "none",
                              boxSizing: "border-box",
                            }}
                          />
                        ]}
                      />

                      <div className={`${libcss.displayFormula} mt-3`} style={{ whiteSpace: "normal", wordBreak: "break-word" , margin: "30px 0"}}>
                        <span className={`${commoncss.label5} ${commoncss.fw500}`} style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px" }}>
                          <span>Formula =</span>
                          {renderFormulaDisplay(formulaItems)}
                        </span>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "20px 12px",
                        flexWrap: "wrap",
                        marginTop: "16px"
                      }}
                    >
                      {formulaItems.map((fitem, index) => (
                        <React.Fragment key={fitem.element ?? index}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "12px"
                            }}
                          >
                            <div className={libcss.formulaCard} style={{ margin: 0, width: "245px", height: "110px", minHeight: "75px", padding: "10px", background: "#f4faf5", border: "1px solid #c2e6d1", borderRadius: "10px" }}>
                              <span
                                className={`${commoncss.label3} ${commoncss.fw600}`}
                                style={{ color: "#205a46", fontSize: "13px", display: "block", marginBottom: "8px" }}
                              >
                                LEVEL 3
                              </span>

                              <div style={{ width: "100%" }}>
                                <Dropdown
   wrapText={true}
   searchable={true}
                                  class2_={commoncss.bgWhite}
                                  options={(activeL2?.subgroup || [])
                                    .filter((sub) => sub && sub.name && !sub.isNewRow)
                                    .map((sub) => ({ label: sub.name, value: sub.name }))}
                                  name="formula"
                                  selected={fitem.value}
                                  onSelect={(val) => updateFormulaItem(index, val)}
                                  placeHolder="Select item"
                                />
                              </div>
                            </div>

                            {index < formulaItems.length - 1 && (
                              <div style={{ marginTop: "0px" }}>
                                <OperatorBtn
                                  value={formulaItems[index + 1].operator}
                                  onChange={(v) => updateFormulaOperator(index + 1, v)}
                                />
                              </div>
                            )}
                            {index === formulaItems.length - 1 && (
                              <div style={{ marginTop: "0px" }}>
                                <OperatorBtn
                                  value={pendingOperator}
                                  onChange={(v) => setPendingOperator(v)}
                                />
                              </div>
                            )}
                          </div>
                        </React.Fragment>
                      ))}

                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <div
                          className={sidePanelStyles.addElementBox1}
                          onClick={addFormulaItem}
                          style={{
                           // width: "245px",
                            height: "110px",
                            marginTop: "0px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "10px",
                            cursor: "pointer"
                          }}
                        >
                          <p style={{ margin: 0, fontSize: "14px", fontWeight: 500, color: "#B3C0BD" }}>
                            <AddElement style={{  width:"15px", height:"15px", verticalAlign: "middle", marginTop: "-3px", marginRight: "4px" }} />
                            Add Element
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className={sidePanelStyles.footer}>
                <button 
                  className={sidePanelStyles.cancelBtn} 
                  onClick={() => setShowAddL3Modal(false)}
                >
                  Cancel
                </button>
                <button 
                  className={sidePanelStyles.applyBtn} 
                  onClick={handleCreateL3}
                >
                  Create
                </button>
              </div>
            </div>
          </div>
        )}

        {editingItem && (
          <div style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            zIndex: 9999,
          }}
          onClick={() => setEditingItem(null)}
          >
            <div
              className={sidePanelStyles.sidePanel}
              style={{
                width: editSelectedItem === "formula" && editFormulaItems.length > 1 ? "966px" : "650px",
                minWidth: editSelectedItem === "formula" && editFormulaItems.length > 1 ? "966px" : "650px",
                maxWidth: editSelectedItem === "formula" && editFormulaItems.length > 1 ? "95vw" : "650px",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div className={sidePanelStyles.panelHeader}>
                <span>Edit Level {editingItem.level} {editingItem.level === 3 ? 'SubNote Group' : 'Note Group'}</span>
                <span 
                  className={sidePanelStyles.close} 
                  onClick={() => setEditingItem(null)}
                >
                  ✕
                </span>
              </div>

              <div className={sidePanelStyles.panelBody} style={{ padding: "20px" }}>
                <div className={libcss.customRadioSection} style={{ marginBottom: "20px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "nowrap", gap: "16px" }}>
                  <RadioGroup
                    row
                    name="editType"
                    value={editSelectedItem}
                    onChange={(e) => setEditSelectedItem(e.target.value)}
                    style={{ margin: 0 }}
                  >
                    <FormControlLabel
                      value="line item"
                      className={libcss.customRadioLabel}
                      control={
                        <Radio
                          sx={{
                            "& .MuiSvgIcon-root": { fontSize: 18 },
                            color: "#D6D6D6",
                            "&.Mui-checked": { color: "#3AB67D" },
                          }}
                        />
                      }
                      label="Line Item"
                    />
                    <FormControlLabel
                      className={libcss.customRadioLabel}
                      value="formula"
                      control={
                        <Radio
                          sx={{
                            "& .MuiSvgIcon-root": { fontSize: 18 },
                            color: "#D6D6D6",
                            "&.Mui-checked": { color: "#3AB67D" },
                          }}
                        />
                      }
                      label="Formula"
                    />
                  </RadioGroup>

                  {(editSelectedItem === "formula" || editSelectedItem === "line item") && (
                    <div style={{ display: "flex", alignItems: "center", gap: "16px", flexShrink: 0 }}>
                      <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "#33584E" }}>
                        <input
                          type="checkbox"
                          checked={editIsBold || editIsTotal || editIsSubtotal}
                          onChange={(e) => {
                            if (!editIsTotal && !editIsSubtotal) {
                              setEditIsBold(e.target.checked);
                            }
                          }}
                          style={{ accentColor: "#3AB67D", margin: 0, width: "16px", height: "16px" }}
                        />
                        Bold
                      </label>
                      <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "#33584E" }}>
                        <input
                          type="checkbox"
                          checked={editIsTotal}
                          onChange={(e) => handleEditTotalToggle(e.target.checked)}
                          style={{ accentColor: "#3AB67D", margin: 0, width: "16px", height: "16px" }}
                        />
                        Total
                      </label>
                      <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "#33584E" }}>
                        <input
                          type="checkbox"
                          checked={editIsSubtotal}
                          onChange={(e) => handleEditSubtotalToggle(e.target.checked)}
                          style={{ accentColor: "#3AB67D", margin: 0, width: "16px", height: "16px" }}
                        />
                        Subtotal
                      </label>
                    </div>
                  )}
                </div>

                {editSelectedItem === "line item" && (
                  <>
                    <InputGroup
                      class_="mb-2"
                      width="100%"
                      label="Line Item Name"
                      inputs={[
                        <input
                          key="edit-line-item-input"
                          name="line item name"
                          value={editItemName}
                          onChange={(e) => setEditItemName(e.target.value)}
                          placeholder="Type something..."
                          style={{
                            width: "100%",
                            height: "37px",
                            padding: "10px 12px",
                            border: "1px solid #c2e6d1",
                            backgroundColor: "#f4faf5",
                            color: "#205a46",
                            borderRadius: "8px",
                            fontSize: "14px",
                            outline: "none",
                            boxSizing: "border-box",
                          }}
                        />
                      ]}
                    />
                    
                    {editingItem?.level === 1 && (
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
                        <span className={`${commoncss.label3} ${commoncss.fs14}`} style={{ color: "#205a46", fontWeight: 500, paddingLeft: "10px" }}>
                          Nature Of Line Item
                        </span>
                        <div className={libcss.customRadioSection}>
                          <RadioGroup
                            row
                            name="editNature"
                            value={editLineItemNature}
                            onChange={(e) => setEditLineItemNature(e.target.value)}
                          >
                            <FormControlLabel
                              value="credit"
                              className={libcss.customRadioLabel}
                              control={
                                <Radio
                                  sx={{
                                    "& .MuiSvgIcon-root": { fontSize: 18 },
                                    color: "#D6D6D6",
                                    "&.Mui-checked": { color: "#3AB67D" },
                                  }}
                                />
                              }
                              label="Credit"
                            />
                            <FormControlLabel
                              value="debit"
                              className={libcss.customRadioLabel}
                              control={
                                <Radio
                                  sx={{
                                    "& .MuiSvgIcon-root": { fontSize: 18 },
                                    color: "#D6D6D6",
                                    "&.Mui-checked": { color: "#3AB67D" },
                                  }}
                                />
                              }
                              label="Debit"
                            />
                          </RadioGroup>
                        </div>
                      </div>
                    )}
                  </>
                )}

                {editSelectedItem === "formula" && (
                  <div>
                    <div style={{ width: "100%" }}>
                      <InputGroup
                        class_="mb-2"
                        width="100%"
                        label="Formula Name"
                        inputs={[
                          <input
                            key="edit-formula-input"
                            name="Formula name"
                            value={editItemName}
                            onChange={(e) => setEditItemName(e.target.value)}
                            placeholder="Enter formula name"
                            style={{
                              width: "100%",
                              height: "37px",
                              padding: "10px 12px",
                              border: "1px solid #c2e6d1",
                              backgroundColor: "#f4faf5",
                              color: "#205a46",
                              borderRadius: "8px",
                              fontSize: "14px",
                              outline: "none",
                              boxSizing: "border-box",
                            }}
                          />
                        ]}
                      />

                      <div className={`${libcss.displayFormula} mt-3`} style={{ whiteSpace: "normal", wordBreak: "break-word" , margin: "30px 0"}}>
                        <span className={`${commoncss.label5} ${commoncss.fw500}`} style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px" }}>
                          <span>Formula =</span>
                          {renderFormulaDisplay(editFormulaItems)}
                        </span>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "20px 12px",
                        flexWrap: "wrap",
                        marginTop: "16px"
                      }}
                    >
                      {editFormulaItems.map((fitem, index) => (
                        <React.Fragment key={fitem.element ?? index}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "12px"
                            }}
                          >
                            <div className={libcss.formulaCard} style={{ margin: 0, width: "245px", height: "110px", minHeight: "75px", padding: "10px", background: "#f4faf5", border: "1px solid #c2e6d1", borderRadius: "10px" }}>
                              <span
                                className={`${commoncss.label3} ${commoncss.fw600}`}
                                style={{ color: "#205a46", fontSize: "13px", display: "block", marginBottom: "8px" }}
                              >
                                LEVEL {editingItem.level}
                              </span>

                              <div style={{ width: "100%" }}>
                                <Dropdown
   wrapText={true}
   searchable={true}
                                  class2_={commoncss.bgWhite}
                                  options={getEditingDropdownOptions()}
                                  name="editFormula"
                                  selected={fitem.value}
                                  onSelect={(val) => updateEditFormulaItem(index, val)}
                                  placeHolder="Select item"
                                />
                              </div>
                            </div>

                            {index < editFormulaItems.length - 1 && (
                              <div style={{ marginTop: "0px" }}>
                                <OperatorBtn
                                  value={editFormulaItems[index + 1].operator}
                                  onChange={(v) => updateEditFormulaOperator(index + 1, v)}
                                />
                              </div>
                            )}
                            {index === editFormulaItems.length - 1 && (
                              <div style={{ marginTop: "0px" }}>
                                <OperatorBtn
                                  value={editPendingOperator}
                                  onChange={(v) => setEditPendingOperator(v)}
                                />
                              </div>
                            )}
                          </div>
                        </React.Fragment>
                      ))}

                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <div
                          className={sidePanelStyles.addElementBox1}
                          onClick={addEditFormulaItem}
                          style={{
                           // width: "245px",
                            height: "110px",
                            marginTop: "0px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "10px",
                            cursor: "pointer"
                          }}
                        >
                          <p style={{ margin: 0, fontSize: "14px", fontWeight: 500, color: "#B3C0BD" }}>
                            <AddElement style={{  width:"15px", height:"15px", verticalAlign: "middle", marginTop: "-3px", marginRight: "4px" }} />
                            Add Element
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className={sidePanelStyles.footer}>
                <button 
                  className={sidePanelStyles.cancelBtn} 
                  onClick={() => setEditingItem(null)}
                >
                  Cancel
                </button>
                <button 
                  className={sidePanelStyles.applyBtn} 
                  onClick={handleUpdateGroupingItem}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        )}

      {/* Render Delete Confirmation Popup */}
      <DeletePopup
        isOpen={deleteConfirmData !== null}
        title={<>Do you want to <span style={{ fontWeight: 700 }}>delete</span> selected items?</>}
        message="Once deleted, you can restore using the bin"
        onConfirm={async () => {
          if (!deleteConfirmData) return;
          const { level, l1Id, l2Id, l3Id } = deleteConfirmData;
          setDeleteConfirmData(null);
          await proceedDeleteGroupingItem(level, l1Id, l2Id, l3Id);
        }}
        onCancel={() => setDeleteConfirmData(null)}
      />

      {showSuccessPopup && (
        <SuccessPopup
          isOpen={showSuccessPopup}
          title="Success"
          message={successPopupMessage}
          onClose={() => setShowSuccessPopup(false)}
        />
      )}
      {errorData && (
        <ErrorPopup
          isOpen={errorData !== null}
          title={errorData.title}
          message={errorData.message}
          onClose={() => setErrorData(null)}
        />
      )}
    </div>
  );
};

export default GroupingDrilldownTable;
